import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import metaTrader from "../../assets/icons/metaTrader_icon.svg";
import cTrader from "../../assets/icons/cTrader_icon.svg";
import coinPayment from "../../assets/icons/coinPayment.svg";
import bitCoinIcon from "../../assets/icons/bit_coint_icn.svg";
import crossIcon from "../../assets/icons/crosIcon.svg";
import CheckoutLogo from "../../assets/images/checkout.png";
import CoinpaymentsLogo from "../../assets/images/payment/CoinPayments Logo White Text.svg";
import coin_icon from "../../assets/icons/coin_icon.svg";
import checkoutCom from "../../assets/icons/checkoutCom.svg";
import usdt_icon from "../../assets/images/USDT_ICON.png";
import eth_icon from "../../assets/images/ETH_ICON.png";
import checkout_bg from "../../assets/images/Ruído.png";
import info_icon from "../../assets/icons/info_icon.svg";
import matchTrade from "../../assets/images/matchtrade.png";
import "./NewCheckout.scss";
import "./Checkout.scss";
import { Button, createSvgIcon, TextField } from "@mui/material";

import { AcctokenD, login, RefftokenD } from "./../../store/actions";
import {
  applyCouponCode,
  deletePaymentIntent,
  getChallenges,
  getUserBasicDetails,
  stripePaymentInitV4,
} from "./../../store/reducers/paymentReducer";
import {
  addCurrentAccount,
  getUserProfile,
  LoadUser,
  sessionTimeout,
} from "./../../store/reducers/userProfileReducer";

import { useAuth } from "./../../components/Routes/UserRoute";
import { dollarUS } from "./../../utilities/formatters";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import { axiosInstance } from "../../Axios";
import CustomLoadingButton from "../../reusableComponents/CustomLoadingButton";

// import backImg from "../../assets/images/BackgroundComp.png";
// import veriOne from "../../assets/images/payment/veriOne.png";
// import veriTwo from "../../assets/images/payment/veriTwo.png";
// import veriThree from "../../assets/images/payment/veriThree.png";
// import veriFour from "../../assets/images/payment/veriFour.png";
// import CheckoutLogo from "../../assets/images/checkout.png";
// import CoinpaymentsLogo from "../../assets/images/payment/CoinPayments Logo White Text.svg";
// import Box from "@mui/material/Box";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import arrow from "../../assets/images/arrow-left.svg";

import {
  Backdrop,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";

const LogoIcon = createSvgIcon(
  <>
    <g clipPath="url(#clip0_2477_11198)">
      <g clipPath="url(#clip1_2477_11198)">
        <path
          d="M22.8271 0C22.8769 0.0306611 22.9382 0.0459917 22.965 0.0843181C23.057 0.222293 23.1375 0.371766 23.218 0.513574C29.2391 11.1108 35.2601 21.7042 41.2812 32.2977C42.6648 34.7314 44.0484 37.1651 45.432 39.6027C45.524 39.7637 45.6083 39.9285 45.6964 40.0933C45.7309 40.1584 45.6773 40.2581 45.6121 40.2657C45.5585 40.2734 45.501 40.2887 45.4473 40.2887C45.2978 40.2926 45.1522 40.2926 45.0027 40.2926C39.3956 40.2926 33.7922 40.2926 28.1851 40.2926C28.0011 40.2926 27.8133 40.2849 27.6294 40.2772C27.5297 40.2734 27.4837 40.1699 27.5335 40.0741C27.5604 40.0243 27.5834 39.9744 27.6102 39.9246C27.7098 39.7483 27.8133 39.5682 27.913 39.3919C28.7638 37.8933 29.6185 36.3948 30.4693 34.8924C30.5345 34.7812 30.5997 34.6662 30.6648 34.5551C30.7338 34.4324 30.8296 34.3635 30.9791 34.3635C31.1477 34.3673 31.3125 34.3596 31.4812 34.3596C32.6693 34.3596 33.8574 34.3596 35.0455 34.3596C35.1912 34.3596 35.3406 34.3405 35.4863 34.3213C35.5093 34.3175 35.5361 34.2715 35.5399 34.237C35.5438 34.2025 35.5361 34.1642 35.5208 34.1335C35.4518 34.0032 35.3828 33.8691 35.31 33.7426C31.3049 26.6943 27.2997 19.65 23.2946 12.6017C23.195 12.4254 23.0915 12.2491 22.9842 12.0728C22.9114 11.954 22.8041 11.9578 22.7274 12.0882C22.6316 12.2453 22.5358 12.4063 22.4476 12.5672C20.4125 16.1469 18.3774 19.7266 16.3422 23.3063C16.2502 23.4673 16.1468 23.6206 16.0509 23.7777C16.0241 23.8199 15.9398 23.8084 15.9091 23.7624C15.8478 23.6704 15.7865 23.5784 15.7328 23.4826C14.7593 21.7732 13.7897 20.0639 12.8162 18.3545C12.7702 18.274 12.7242 18.1935 12.6821 18.1092C12.6246 18.0019 12.6322 17.8946 12.6897 17.7911C12.7587 17.6608 12.8315 17.5305 12.9043 17.4002C14.3339 14.886 15.7635 12.3718 17.1931 9.85372C18.9523 6.75695 20.7114 3.66017 22.4706 0.567231C22.5818 0.383264 22.6737 0.180134 22.8271 0Z"
          fill="#04D9FF"
        />
        <path
          d="M26.2116 30.0709C26.2039 30.1054 26.2001 30.1475 26.1848 30.1782C26.1273 30.2932 26.0621 30.4082 26.0008 30.5193C22.7852 36.1801 19.5658 41.8409 16.3464 47.4979C16.2544 47.6589 16.1509 47.8122 16.0513 47.9655C16.0244 48.0077 15.9363 48.0038 15.9056 47.9617C15.8175 47.8199 15.7255 47.6819 15.6412 47.5362C14.752 45.9725 13.8628 44.4088 12.9737 42.8451C11.7817 40.7486 10.5898 38.6522 9.39398 36.5596C9.31733 36.4254 9.279 36.2414 9.0912 36.1955C8.93789 36.2568 8.89957 36.4139 8.82675 36.5404C8.23652 37.5714 7.65013 38.6024 7.06373 39.6333C7.01774 39.7138 6.97175 39.7943 6.92576 39.8748C6.68813 40.2887 6.7073 40.2925 6.23588 40.2925C4.28507 40.2925 2.33809 40.2925 0.387271 40.2925C0.314451 40.2925 0.237798 40.2887 0.164978 40.2849C0.0155047 40.2772 -0.0419849 40.1929 0.0193373 40.0741C0.0959902 39.9284 0.176476 39.779 0.260794 39.6372C1.57922 37.3146 2.89765 34.992 4.21991 32.6694C5.73381 30.0096 7.24387 27.3497 8.75776 24.6899C8.84974 24.5289 8.95323 24.3756 9.05671 24.2223C9.0682 24.207 9.13719 24.207 9.14869 24.2223C9.23301 24.3411 9.31733 24.4637 9.39015 24.594C10.1337 25.901 10.8772 27.2041 11.6169 28.511C12.9545 30.8642 14.2921 33.2213 15.6374 35.5707C15.7332 35.7355 15.76 35.9693 16.0015 36.0268C16.1778 35.931 16.2276 35.7394 16.3157 35.5861C18.3355 32.0409 20.3515 28.4918 22.3675 24.9428C22.4786 24.7512 22.5859 24.5557 22.6971 24.3603C22.8159 24.1571 22.8887 24.1533 23.0037 24.3449C23.042 24.4101 23.0803 24.4714 23.1148 24.5366C24.0768 26.2306 25.0388 27.9208 26.0008 29.6148C26.066 29.726 26.1273 29.8409 26.1848 29.9559C26.2078 29.9942 26.2078 30.0364 26.2116 30.0709Z"
          fill="#04D9FF"
        />
        <path
          d="M123.407 14.9511C121.625 14.9511 119.842 14.9511 118.06 14.9511C117.876 14.9511 117.689 14.9435 117.505 14.9626C117.34 14.978 117.175 15.0124 117.014 15.0546C116.903 15.0853 116.819 15.1657 116.78 15.2769C116.738 15.3995 116.704 15.526 116.688 15.6525C116.669 15.8365 116.669 16.0243 116.669 16.2082C116.669 18.1935 116.669 20.1788 116.669 22.1642C116.669 22.2753 116.673 22.3864 116.673 22.4976C116.677 22.7544 116.788 22.9613 116.96 23.1415C117.117 23.3024 117.301 23.4251 117.501 23.5286C117.781 23.678 118.076 23.7854 118.378 23.8773C118.539 23.9272 118.704 23.9617 118.857 24.0192C119.015 24.0766 119.168 24.1456 119.314 24.2223C119.517 24.3296 119.586 24.5097 119.563 24.7359C119.54 24.9582 119.432 25.0846 119.218 25.0923C118.976 25.1038 118.735 25.1038 118.493 25.0961C117.194 25.054 115.895 25.0425 114.596 25.0961C113.818 25.1268 113.04 25.1919 112.262 25.2379C112.131 25.2456 112.001 25.2494 111.874 25.2379C111.744 25.2303 111.637 25.123 111.61 24.9888C111.602 24.9543 111.595 24.916 111.595 24.8777C111.568 24.5519 111.675 24.3833 111.982 24.2951C112.104 24.2606 112.235 24.2338 112.361 24.2223C112.568 24.2031 112.764 24.1456 112.951 24.0651C113.43 23.862 113.726 23.4979 113.81 22.9843C113.848 22.7467 113.86 22.5053 113.875 22.2638C113.883 22.1527 113.879 22.0415 113.879 21.9304C113.879 17.1281 113.879 12.3219 113.879 7.51963C113.879 7.22451 113.875 6.9294 113.837 6.63045C113.764 6.11688 113.499 5.73745 113.078 5.45767C112.859 5.31203 112.622 5.20854 112.369 5.14339C112.12 5.0744 111.867 5.01308 111.618 4.94409C111.529 4.9211 111.441 4.89044 111.357 4.85211C111.288 4.82145 111.25 4.75629 111.231 4.67964C111.2 4.54933 111.2 4.42285 111.227 4.29254C111.25 4.17373 111.319 4.08558 111.434 4.05492C111.575 4.01659 111.721 3.98593 111.867 3.97443C112.012 3.96294 112.162 3.97827 112.311 3.98593C114.147 4.10091 115.983 4.10858 117.823 4.04725C118.102 4.03959 118.378 4.00126 118.654 3.98593C118.819 3.97827 118.988 3.97827 119.153 3.99743C119.294 4.01276 119.383 4.11241 119.417 4.25038C119.432 4.3232 119.436 4.39602 119.436 4.46884C119.44 4.58766 119.386 4.69114 119.283 4.74863C119.156 4.82145 119.018 4.8866 118.877 4.92493C118.574 5.00925 118.263 5.07057 117.957 5.15105C117.761 5.20088 117.562 5.25837 117.37 5.32352C117.091 5.41934 116.907 5.62247 116.799 5.89842C116.73 6.07089 116.681 6.25102 116.677 6.43882C116.669 6.60746 116.665 6.77226 116.665 6.9409C116.665 8.61193 116.665 10.2791 116.665 11.9502C116.665 12.0996 116.669 12.2453 116.673 12.3947C116.677 12.5442 116.719 12.686 116.78 12.824C116.895 13.077 117.091 13.2379 117.359 13.3069C117.501 13.3414 117.65 13.3567 117.8 13.3644C117.949 13.3759 118.095 13.3682 118.244 13.3682C121.697 13.3682 125.147 13.3682 128.6 13.3682C128.769 13.3682 128.934 13.3721 129.102 13.3606C129.286 13.3491 129.47 13.3299 129.654 13.3031C129.811 13.2801 129.922 13.1766 129.984 13.031C130.018 12.9466 130.049 12.8547 130.06 12.7665C130.087 12.4906 130.118 12.2108 130.118 11.9348C130.122 10.2485 130.122 8.55827 130.118 6.87191C130.118 6.61512 130.095 6.35067 130.056 6.09772C129.995 5.69912 129.765 5.41551 129.374 5.2967C129.037 5.19705 128.692 5.12806 128.351 5.03991C128.171 4.99392 127.991 4.95176 127.814 4.89044C127.73 4.86361 127.646 4.80995 127.573 4.75629C127.462 4.67581 127.404 4.56083 127.404 4.42285C127.404 4.3692 127.408 4.31171 127.416 4.25805C127.454 4.03576 127.565 3.91694 127.78 3.90545C127.964 3.89395 128.152 3.89778 128.336 3.91311C129.298 3.97827 130.26 4.05875 131.229 4.02043C132.099 3.98593 132.973 3.93227 133.843 3.89012C134.157 3.87478 134.472 3.85179 134.79 3.84412C134.92 3.84029 135.047 3.85945 135.177 3.87478C135.28 3.89012 135.376 3.9936 135.392 4.10474C135.403 4.21589 135.415 4.32704 135.411 4.43435C135.403 4.59915 135.307 4.7218 135.158 4.77162C134.966 4.83678 134.763 4.87127 134.564 4.91726C134.403 4.95559 134.238 4.98242 134.077 5.03224C133.376 5.25454 133.019 5.74895 132.958 6.46565C132.946 6.59596 132.95 6.72627 132.95 6.85658C132.95 11.977 132.95 17.0936 132.95 22.214C132.95 22.4554 132.958 22.6931 133.023 22.9307C133.119 23.2948 133.326 23.5669 133.655 23.7355C133.851 23.839 134.062 23.9233 134.272 23.9885C134.571 24.0843 134.882 24.1495 135.185 24.2338C135.346 24.2798 135.506 24.3258 135.656 24.3948C135.821 24.4676 135.909 24.6132 135.901 24.7972C135.894 24.9045 135.867 25.0156 135.832 25.1191C135.817 25.1613 135.759 25.1996 135.713 25.2226C135.591 25.2801 135.461 25.2686 135.33 25.2571C134.924 25.2264 134.514 25.2034 134.108 25.1689C133.31 25.1 132.513 25.0808 131.716 25.0808C130.789 25.0808 129.861 25.1 128.934 25.1115C128.711 25.1153 128.489 25.1115 128.267 25.0961C128.079 25.0846 127.96 24.9581 127.941 24.7742C127.933 24.7014 127.929 24.6247 127.933 24.5519C127.937 24.3679 128.037 24.2376 128.19 24.1495C128.336 24.0651 128.497 24.0192 128.661 23.9923C128.845 23.9617 129.029 23.9272 129.202 23.8697C129.7 23.6972 130.01 23.3599 130.087 22.8272C130.106 22.7007 130.118 22.5704 130.125 22.4401C130.133 22.3481 130.129 22.2561 130.129 22.1603C130.129 20.2517 130.129 18.3392 130.129 16.4305C130.129 16.1162 130.114 15.7981 130.06 15.4877C130.01 15.2232 129.85 15.0584 129.585 15.0048C129.459 14.978 129.328 14.9665 129.198 14.9588C129.033 14.9511 128.865 14.955 128.696 14.955C126.937 14.9511 125.174 14.9511 123.407 14.9511Z"
          fill="#04D9FF"
        />
        <path
          d="M149.531 17.6033C148.435 17.6225 147.343 17.565 146.25 17.5152C145.334 17.473 145.53 17.3657 145.181 18.2012C144.782 19.1594 144.391 20.1214 144 21.0834C143.866 21.4091 143.751 21.7426 143.682 22.0875C143.579 22.5934 143.755 23.2258 144.33 23.5669C144.472 23.6512 144.625 23.7202 144.775 23.793C145.039 23.9234 145.311 24.046 145.572 24.1878C145.717 24.2683 145.855 24.3679 145.982 24.4714C146.185 24.6439 146.116 24.9697 145.863 25.054C145.794 25.077 145.721 25.1 145.648 25.1038C145.499 25.1115 145.353 25.1153 145.204 25.1076C144.924 25.0923 144.648 25.077 144.372 25.0463C143.836 24.9888 143.299 24.985 142.759 24.985C141.755 24.985 140.758 25.0846 139.769 25.2533C139.589 25.2839 139.401 25.3069 139.217 25.3069C139.033 25.3108 138.915 25.192 138.838 25.0272C138.761 24.8585 138.761 24.6975 138.884 24.5596C138.968 24.4638 139.064 24.3679 139.171 24.299C139.359 24.1801 139.555 24.069 139.758 23.9808C140.356 23.7241 140.816 23.3063 141.195 22.7851C141.467 22.4095 141.686 21.9994 141.881 21.5778C142.383 20.4816 142.893 19.3893 143.391 18.2932C144.292 16.3002 145.2 14.3111 146.078 12.3066C146.963 10.2868 147.783 8.23635 148.485 6.14373C148.672 5.58033 148.86 5.01693 149.017 4.44587C149.117 4.07794 149.32 3.81349 149.65 3.64102C149.83 3.5452 150.014 3.45705 150.202 3.38423C150.374 3.31524 150.543 3.37656 150.642 3.51837C150.696 3.59502 150.75 3.67168 150.788 3.756C150.869 3.9208 150.949 4.08944 151.018 4.2619C151.256 4.8253 151.493 5.3887 151.727 5.9521C153.712 10.6892 155.767 15.3957 157.871 20.0792C158.135 20.6694 158.404 21.2635 158.668 21.8537C158.745 22.0224 158.817 22.191 158.902 22.3596C159.323 23.1875 159.971 23.7739 160.837 24.1112C161.029 24.184 161.224 24.2415 161.412 24.3219C161.822 24.4906 161.903 24.6899 161.738 25.1115C161.726 25.146 161.703 25.1766 161.68 25.2073C161.638 25.2763 161.565 25.3031 161.493 25.3069C161.439 25.3108 161.381 25.3069 161.328 25.2954C160.266 25.0808 159.193 25.0425 158.116 25.0387C156.966 25.031 155.816 25.0616 154.667 25.1575C154.502 25.1728 154.333 25.1805 154.165 25.1728C154.053 25.169 153.942 25.1498 153.839 25.1191C153.548 25.0348 153.456 24.6669 153.674 24.4523C153.766 24.3641 153.877 24.2875 153.988 24.23C154.153 24.1456 154.329 24.0843 154.494 24C154.709 23.8927 154.923 23.7815 155.134 23.6627C155.23 23.6091 155.322 23.5439 155.41 23.4711C155.771 23.176 155.924 22.9192 155.721 22.4018C155.679 22.2983 155.644 22.1948 155.602 22.0913C155.023 20.7461 154.448 19.4008 153.866 18.0556C153.808 17.9214 153.743 17.7873 153.67 17.657C153.632 17.5918 153.563 17.5535 153.486 17.5497C153.413 17.5458 153.337 17.542 153.264 17.5458C152.356 17.6072 151.447 17.588 150.539 17.5957C150.198 17.6072 149.864 17.6033 149.531 17.6033ZM149.673 16.3999C150.669 16.3769 151.635 16.3539 152.601 16.3309C152.693 16.3271 152.785 16.3232 152.877 16.3156C152.984 16.3079 153.049 16.2197 153.015 16.1278C152.969 16.0051 152.923 15.8863 152.873 15.7675C151.88 13.5331 150.888 11.2948 149.895 9.06037C149.849 8.96072 149.807 8.85724 149.753 8.75759C149.719 8.69244 149.669 8.63878 149.619 8.58129C149.535 8.48547 149.347 8.49314 149.278 8.60045C149.201 8.7231 149.129 8.85341 149.071 8.99138C148.132 11.2488 147.193 13.5101 146.254 15.7675C146.22 15.8518 146.185 15.94 146.158 16.0281C146.116 16.1469 146.177 16.2389 146.315 16.2581C146.48 16.2772 146.649 16.2964 146.814 16.3041C147.779 16.3386 148.741 16.3692 149.673 16.3999Z"
          fill="#04D9FF"
        />
        <path
          d="M59.6589 17.5918C58.2408 17.6302 57.1294 17.5688 56.0141 17.5113C55.8301 17.4998 55.6423 17.5037 55.4583 17.5037C55.3817 17.5037 55.3165 17.5535 55.282 17.6187C55.2399 17.6991 55.2015 17.7835 55.1671 17.8716C54.7033 19.0022 54.2396 20.1367 53.7796 21.2712C53.703 21.459 53.6378 21.6544 53.588 21.8499C53.5497 22.0109 53.5267 22.1795 53.519 22.3443C53.496 22.8732 53.7221 23.2756 54.1667 23.5593C54.3239 23.6589 54.4963 23.7279 54.6611 23.8122C54.9256 23.9425 55.1977 24.069 55.4583 24.2108C55.604 24.2913 55.7381 24.3948 55.8608 24.5021C56.0102 24.6324 55.9949 24.8662 55.8263 24.985C55.7534 25.0387 55.6653 25.0846 55.5771 25.0961C55.4123 25.1191 55.2437 25.123 55.0789 25.1153C54.7646 25.1 54.4503 25.077 54.1361 25.0501C53.1894 24.9697 52.2466 24.9735 51.2999 25.0501C50.6905 25.1 50.0811 25.1728 49.4794 25.2839C49.3338 25.3108 49.1843 25.3184 49.0387 25.3108C48.8777 25.3031 48.7665 25.1996 48.6975 25.0578C48.6209 24.8968 48.6017 24.7282 48.7205 24.5864C48.8125 24.4714 48.9237 24.3679 49.0463 24.2875C49.2341 24.1686 49.4334 24.0652 49.6365 23.9732C50.1961 23.7241 50.633 23.337 50.9971 22.854C51.2999 22.4516 51.5337 22.0109 51.7445 21.5548C52.2542 20.4433 52.7716 19.3319 53.2776 18.2204C54.2472 16.0933 55.2245 13.9738 56.1367 11.8199C56.9454 9.90739 57.7196 7.97957 58.3788 6.00959C58.5551 5.48069 58.7276 4.95178 58.8732 4.41905C58.9614 4.08944 59.1453 3.85182 59.4289 3.68701C59.6206 3.57587 59.8199 3.47622 60.0268 3.39573C60.23 3.31525 60.4024 3.37274 60.5059 3.5567C60.6247 3.76367 60.7359 3.97829 60.8355 4.20059C60.9927 4.55702 61.1383 4.91729 61.2878 5.27756C63.5912 10.8042 66.0019 16.2887 68.4625 21.7502C68.5391 21.9189 68.6158 22.0875 68.6924 22.2562C69.137 23.1952 69.8537 23.8275 70.8272 24.1725C70.9652 24.2223 71.1108 24.2645 71.2488 24.3181C71.6397 24.4714 71.7892 24.6899 71.5708 25.1498C71.5209 25.2571 71.4175 25.3223 71.3063 25.3108C71.2143 25.3031 71.1223 25.2878 71.0304 25.2724C70.5168 25.1805 70.0032 25.1153 69.482 25.0885C67.8493 25.0003 66.2166 25.0387 64.5877 25.1536C64.3846 25.169 64.1814 25.1728 63.9745 25.1766C63.8442 25.1805 63.7177 25.146 63.5989 25.0885C63.4264 25.0118 63.3459 24.7972 63.4187 24.6209C63.4686 24.4944 63.5529 24.3948 63.6679 24.3296C63.7943 24.2568 63.9323 24.1955 64.0664 24.1303C64.3156 24.0077 64.5724 23.9004 64.8176 23.7662C64.9939 23.6704 65.1626 23.5478 65.3236 23.4213C65.4232 23.3408 65.5037 23.2335 65.5765 23.13C65.6647 23.0035 65.6953 22.854 65.6532 22.7046C65.5842 22.4746 65.5114 22.2447 65.4194 22.0224C64.9365 20.8802 64.4459 19.7381 63.9515 18.596C63.825 18.3047 63.6908 18.0211 63.5605 17.7336C63.4992 17.5995 63.3919 17.542 63.2501 17.5458C62.9358 17.5573 62.6215 17.5842 62.3034 17.5842C61.3223 17.5918 60.3373 17.5918 59.6589 17.5918ZM59.5209 16.3999C60.5098 16.3769 61.4564 16.3577 62.3992 16.3347C62.5104 16.3309 62.6215 16.3232 62.7327 16.3117C62.8323 16.3041 62.8975 16.2044 62.863 16.1163C62.7863 15.9285 62.7135 15.7368 62.6292 15.5529C61.6825 13.4181 60.7359 11.2871 59.7892 9.15236C59.7356 9.03355 59.6857 8.91473 59.6282 8.79976C59.5938 8.7346 59.5516 8.67328 59.5056 8.61579C59.4098 8.48931 59.2067 8.48165 59.1223 8.61196C59.0342 8.75376 58.9575 8.8994 58.8924 9.05271C57.9687 11.2756 57.045 13.4986 56.1252 15.7253C56.0754 15.8441 56.0371 15.9668 55.9949 16.0894C55.9796 16.1278 56.0294 16.2121 56.0677 16.2236C56.2632 16.2964 56.4701 16.2926 56.6733 16.3002C57.6353 16.3386 58.5973 16.3692 59.5209 16.3999Z"
          fill="#04D9FF"
        />
        <path
          d="M95.6738 14.794C95.6738 12.3449 95.6738 9.89588 95.6738 7.44683C95.6738 7.22453 95.6738 7.00224 95.6584 6.77995C95.6086 6.15523 95.2943 5.70297 94.7501 5.40403C94.5393 5.28905 94.3132 5.2009 94.0756 5.14724C93.9299 5.11275 93.7881 5.08209 93.6425 5.03993C93.5352 5.00927 93.4278 4.97477 93.3282 4.92878C92.9948 4.77547 92.9028 4.48419 93.0791 4.14692C93.1327 4.04344 93.2247 3.97062 93.3435 3.97062C93.4892 3.96679 93.6425 3.97062 93.7843 3.99745C94.5355 4.13159 95.2943 4.18525 96.057 4.16992C96.8542 4.15075 97.6514 4.12776 98.4486 4.10093C99.859 4.05494 101.269 3.98595 102.68 4.0626C103.741 4.12009 104.776 4.32322 105.765 4.73332C106.317 4.96327 106.831 5.25455 107.298 5.62632C108.302 6.42351 108.893 7.46216 109.1 8.72693C109.249 9.6391 109.211 10.5359 108.981 11.4289C108.743 12.3488 108.283 13.1421 107.628 13.8243C107.041 14.4337 106.352 14.8975 105.593 15.2616C104.749 15.664 103.864 15.9285 102.944 16.0818C102.155 16.2121 101.361 16.2887 100.564 16.2849C100.192 16.2849 99.8245 16.2734 99.4528 16.2312C99.2151 16.2044 98.9698 16.2082 98.7322 16.2044C98.6287 16.2044 98.5138 16.3117 98.5061 16.4152C98.4908 16.6183 98.4793 16.8215 98.4754 17.0246C98.4716 18.619 98.4754 20.2172 98.4754 21.8116C98.4754 22.053 98.4716 22.2945 98.4793 22.5359C98.4831 22.6854 98.4908 22.8349 98.5138 22.9805C98.5674 23.2986 98.7361 23.5324 99.0503 23.6321C99.3493 23.7279 99.6559 23.8045 99.9625 23.8812C100.177 23.9349 100.403 23.9578 100.618 24.0115C100.779 24.0537 100.94 24.1035 101.085 24.1801C101.396 24.3373 101.473 24.6861 101.277 24.985C101.25 25.0272 101.197 25.0655 101.147 25.0808C101.059 25.1038 100.963 25.1191 100.871 25.1191C100.649 25.123 100.426 25.1191 100.204 25.1115C98.9239 25.0693 97.6438 25.0731 96.3636 25.1191C95.6776 25.1421 94.9916 25.1958 94.3055 25.2303C94.1407 25.238 93.9721 25.2418 93.8073 25.2226C93.4163 25.1805 93.3435 24.7742 93.4508 24.5519C93.4892 24.4753 93.5697 24.4063 93.6463 24.3641C93.7919 24.2836 93.9568 24.2453 94.1254 24.2376C94.3132 24.23 94.4895 24.1763 94.6658 24.1112C95.1794 23.9272 95.4936 23.5631 95.6125 23.0342C95.6469 22.8732 95.6584 22.7046 95.6699 22.5359C95.6814 22.352 95.6738 22.1642 95.6738 21.9802C95.6738 19.581 95.6738 17.1856 95.6738 14.794ZM98.4793 10.4823C98.4793 10.6126 98.4793 10.7429 98.4793 10.8732C98.4793 11.9655 98.4793 13.0616 98.4793 14.1539C98.4793 14.3034 98.4831 14.4491 98.4946 14.5985C98.5023 14.7173 98.5751 14.8055 98.6786 14.8592C98.7629 14.9013 98.8472 14.9396 98.9354 14.9588C99.2075 15.0163 99.4796 15.0776 99.7594 15.0776C100.093 15.0776 100.426 15.0853 100.76 15.0891C101.223 15.0929 101.687 15.0585 102.143 14.9703C102.806 14.84 103.435 14.6254 104.01 14.2728C104.987 13.671 105.623 12.8164 105.911 11.7011C106.099 10.9729 106.133 10.237 106.079 9.49346C106.041 8.93772 105.961 8.38966 105.8 7.85309C105.443 6.66113 104.684 5.86778 103.492 5.49218C102.887 5.30055 102.274 5.18173 101.637 5.14724C101.453 5.13574 101.266 5.13574 101.082 5.12041C100.637 5.08592 100.192 5.12041 99.7479 5.14724C99.5218 5.16257 99.3109 5.23156 99.104 5.31588C98.8894 5.40403 98.7361 5.565 98.6441 5.77963C98.5636 5.96743 98.5023 6.16289 98.4946 6.36985C98.4831 6.59215 98.4716 6.81444 98.4716 7.03673C98.4793 8.18653 98.4793 9.33632 98.4793 10.4823Z"
          fill="#04D9FF"
        />
        <path
          d="M82.3288 25.0731C81.1982 25.0846 80.0637 25.0885 78.9331 25.1153C77.8369 25.1421 76.7446 25.1958 75.6523 25.2341C75.4684 25.2418 75.2844 25.2303 75.0966 25.2188C74.997 25.2111 74.9318 25.146 74.8935 25.054C74.8437 24.9313 74.8245 24.8049 74.8475 24.6746C74.8743 24.5404 74.9433 24.4331 75.0659 24.3679C75.2154 24.2913 75.3764 24.2453 75.545 24.2376C75.7328 24.23 75.9091 24.1763 76.0854 24.1188C76.599 23.9425 76.9286 23.5937 77.0436 23.0572C77.0819 22.877 77.1011 22.6931 77.1164 22.5091C77.1279 22.3788 77.1202 22.2485 77.1202 22.1182C77.1202 17.3887 77.1202 12.6592 77.1202 7.93358C77.1202 7.52348 77.1126 7.11722 77.0398 6.7148C77.0244 6.62281 77.0129 6.53083 76.9899 6.44268C76.8788 5.97126 76.6182 5.5995 76.2119 5.33121C75.9934 5.18557 75.7597 5.07826 75.5182 4.97861C75.3802 4.92112 75.2422 4.8713 75.1119 4.79464C74.8705 4.65667 74.7785 4.40755 74.8475 4.12393C74.8628 4.07028 74.882 4.01662 74.905 3.96679C74.9356 3.89397 74.9931 3.84415 75.0698 3.83265C75.1963 3.81732 75.3266 3.79816 75.4569 3.80582C75.7328 3.82115 76.0126 3.84415 76.2886 3.87481C76.806 3.9323 77.3234 3.94763 77.8446 3.9553C79.0902 3.98212 80.3282 3.90547 81.5699 3.80582C81.7347 3.79432 81.9034 3.77899 82.0682 3.78283C82.2943 3.79049 82.4476 3.9438 82.4668 4.16992C82.4744 4.26191 82.4744 4.35389 82.463 4.44587C82.4476 4.60684 82.3595 4.72949 82.2138 4.78698C82.0605 4.8483 81.8957 4.88663 81.7347 4.92879C81.4665 5.00544 81.1943 5.06676 80.9337 5.15491C80.7574 5.2124 80.5888 5.29289 80.4278 5.38104C80.2209 5.49218 80.0867 5.66849 80.0292 5.89461C79.9641 6.14373 79.8989 6.39669 79.9027 6.66114C79.9027 6.86427 79.8989 7.0674 79.8989 7.27436C79.8989 11.8735 79.8989 16.4727 79.8989 21.0719C79.8989 21.2558 79.8989 21.4436 79.9027 21.6276C79.9066 21.8921 79.9756 22.1412 80.0637 22.3865C80.2209 22.8234 80.5236 23.1415 80.9491 23.337C81.3247 23.5094 81.7232 23.5938 82.1257 23.6551C83.0838 23.7969 84.0497 23.8084 85.0155 23.7586C85.644 23.7279 86.2688 23.6397 86.8782 23.4634C87.6408 23.245 88.2426 22.8081 88.7063 22.1757C88.9363 21.8614 89.1317 21.5241 89.2927 21.1677C89.354 21.0335 89.4154 20.8956 89.4882 20.7691C89.63 20.5276 89.8408 20.4472 90.1014 20.52C90.1359 20.5315 90.1742 20.5391 90.2087 20.5506C90.4808 20.6388 90.5767 20.8611 90.5115 21.114C90.4042 21.5433 90.3199 21.9802 90.2279 22.4171C90.0976 23.0533 90.0171 23.6972 89.9941 24.3488C89.9864 24.5327 89.9749 24.7205 89.9558 24.9045C89.9443 25.0348 89.8446 25.146 89.7105 25.1728C89.6032 25.1958 89.492 25.215 89.3809 25.2188C89.1969 25.2226 89.0091 25.2226 88.8251 25.215C86.6712 25.0885 84.5019 25.077 82.3288 25.0731Z"
          fill="#04D9FF"
        />
        <path
          d="M119.962 35.5324C120.629 35.5324 121.3 35.5324 121.967 35.5324C122.116 35.5324 122.262 35.5439 122.411 35.5554C122.484 35.5592 122.553 35.6359 122.545 35.7049C122.488 36.2184 122.472 36.7397 122.281 37.2303C122.093 37.7208 121.832 38.1654 121.495 38.564C120.832 39.3497 120.004 39.8939 119.023 40.1967C117.176 40.764 114.439 40.0856 113.358 37.4487C113.148 36.9313 113.021 36.3909 112.994 35.8313C112.96 35.1031 112.998 34.3864 113.24 33.6927C113.864 31.9105 115.114 30.8489 116.961 30.4771C118.069 30.3468 119.146 30.4388 120.165 30.9256C121.338 31.489 122.089 32.4088 122.426 33.6621C122.465 33.8 122.407 33.8997 122.285 33.8997C121.913 33.9035 121.545 33.9035 121.173 33.9035C121.097 33.9035 121.031 33.8575 120.993 33.7885C120.943 33.6889 120.901 33.5854 120.855 33.4858C120.606 32.9185 120.2 32.4969 119.652 32.221C118.755 31.7687 117.812 31.6461 116.842 31.922C115.62 32.2708 114.853 33.1025 114.493 34.306C114.248 35.13 114.278 35.9578 114.573 36.7665C114.995 37.9048 115.781 38.6828 116.973 38.9588C118.64 39.3459 120.089 38.587 120.782 37.2533C120.817 37.1881 120.828 37.1153 120.851 37.0425C120.863 37.0003 120.809 36.9198 120.767 36.916C120.621 36.9083 120.472 36.893 120.326 36.8892C119.471 36.8853 118.621 36.8891 117.766 36.8853C117.636 36.8853 117.509 36.8662 117.383 36.847C117.352 36.8432 117.321 36.8048 117.306 36.7742C117.291 36.755 117.279 36.7167 117.279 36.6784C117.279 36.3641 117.279 36.0498 117.283 35.7317C117.283 35.6359 117.364 35.5516 117.456 35.5439C117.605 35.5362 117.751 35.5286 117.9 35.5286C118.59 35.5324 119.276 35.5324 119.962 35.5324Z"
          fill="#04D9FF"
        />
        <path
          d="M133.158 35.4098C133.127 32.5775 135.446 30.4044 138.109 30.3852C140.823 30.3622 143.157 32.5315 143.176 35.3638C143.191 38.1156 140.984 40.3846 138.155 40.3846C135.327 40.3884 133.142 38.1156 133.158 35.4098ZM141.781 35.3906C141.789 33.4436 140.217 31.7879 138.174 31.7726C136.289 31.7573 134.533 33.2405 134.545 35.4174C134.556 37.4794 136.178 39.0163 138.174 39.001C140.405 38.978 141.804 37.1843 141.781 35.3906Z"
          fill="#04D9FF"
        />
        <path
          d="M126.861 35.9808C126.861 35.816 126.857 35.6704 126.861 35.5209C126.861 35.4519 126.938 35.3753 127.003 35.3715C127.114 35.3638 127.225 35.3561 127.336 35.3561C127.708 35.3523 128.08 35.3523 128.448 35.3561C128.655 35.3561 128.854 35.3293 129.049 35.268C129.67 35.0725 130.05 34.6586 130.195 34.0262C130.291 33.6123 130.234 33.2137 130.057 32.8342C129.785 32.2517 129.329 31.9144 128.685 31.8339C128.632 31.8263 128.574 31.8186 128.52 31.8186C127.873 31.8186 127.221 31.8186 126.573 31.8186C126.52 31.8186 126.458 31.8263 126.412 31.8493C126.363 31.8684 126.313 31.8991 126.305 31.9642C126.298 32.0179 126.282 32.0715 126.282 32.129C126.278 32.2977 126.278 32.4625 126.278 32.6311C126.278 34.9499 126.278 37.2648 126.278 39.5835C126.278 40.2657 126.321 40.2236 125.65 40.2236C124.899 40.2236 124.956 40.2926 124.956 39.5375C124.956 36.7397 124.956 33.938 124.956 31.1402C124.956 30.9907 124.956 30.8451 124.964 30.6956C124.971 30.5347 125.04 30.4695 125.209 30.4618C125.263 30.458 125.32 30.458 125.378 30.458C126.416 30.458 127.455 30.458 128.494 30.458C128.754 30.458 129.011 30.4887 129.264 30.55C130.023 30.7301 130.625 31.1364 131.042 31.7879C131.594 32.6426 131.751 33.5778 131.46 34.5551C131.192 35.4673 130.59 36.0882 129.697 36.4254C129.54 36.4829 129.383 36.5366 129.229 36.5979C129.21 36.6056 129.191 36.6707 129.203 36.6899C129.272 36.801 129.341 36.9083 129.425 37.008C130.161 37.8895 130.904 38.7672 131.64 39.6487C131.748 39.7752 131.851 39.9055 131.951 40.0396C131.97 40.0626 131.97 40.1086 131.97 40.1431C131.97 40.1891 131.939 40.2082 131.893 40.2082C131.874 40.2082 131.855 40.2159 131.84 40.2159C131.414 40.2159 130.985 40.2159 130.559 40.2197C130.441 40.2197 130.345 40.1814 130.268 40.0894C130.184 39.9898 130.1 39.894 130.015 39.7943C129.08 38.6675 128.141 37.5407 127.206 36.4139C127.083 36.2683 126.968 36.1188 126.861 35.9808Z"
          fill="#04D9FF"
        />
        <path
          d="M56.7999 34.0607C56.6888 34.0607 56.5776 34.0569 56.4665 34.0607C56.2634 34.0684 56.1101 34.0109 56.0296 33.8001C55.9721 33.6468 55.8878 33.4973 55.7996 33.3555C55.2554 32.4778 54.4658 31.9834 53.4464 31.8531C51.6642 31.6232 49.9663 32.8688 49.6061 34.6663C49.4336 35.5325 49.5256 36.3718 49.9548 37.1498C50.6447 38.4108 51.7447 38.9933 53.1704 38.9435C54.4658 38.8975 55.4163 38.2651 56.0219 37.1192C56.0564 37.054 56.0909 36.9889 56.1177 36.9199C56.1905 36.7091 56.3438 36.6516 56.5508 36.6592C56.7731 36.6669 56.9954 36.6593 57.2177 36.6631C57.486 36.6669 57.5281 36.7206 57.4515 36.9505C57.0069 38.3303 56.1599 39.3613 54.8108 39.9362C52.9558 40.7257 50.5949 40.2313 49.2688 38.4529C48.5827 37.5293 48.1956 36.4983 48.2263 35.3485C48.2876 33.1294 49.6406 31.2092 51.9286 30.6343C53.7108 30.1859 55.677 30.8451 56.7654 32.4663C57.0376 32.8688 57.2407 33.3057 57.3902 33.7656C57.394 33.7848 57.3978 33.8001 57.4017 33.8193C57.4361 33.9457 57.371 34.0531 57.2522 34.0569C57.1027 34.0607 56.9571 34.0569 56.8076 34.0569C56.7999 34.0531 56.7999 34.0569 56.7999 34.0607Z"
          fill="#04D9FF"
        />
        <path
          d="M155.391 35.4021C155.391 34.0109 155.391 32.6196 155.391 31.2284C155.391 31.0636 155.406 30.8949 155.417 30.7301C155.421 30.665 155.502 30.5922 155.567 30.5883C155.659 30.5807 155.751 30.573 155.843 30.573C156.862 30.573 157.886 30.573 158.905 30.573C159.185 30.573 159.461 30.6113 159.733 30.6726C160.454 30.8375 161.025 31.2245 161.446 31.8263C161.783 32.3092 161.971 32.8458 162.017 33.4321C162.056 33.9342 162.029 34.4325 161.864 34.9154C161.55 35.8275 160.967 36.4868 160.043 36.8087C159.71 36.9275 159.365 36.9927 159.009 36.9888C158.472 36.985 157.932 36.9888 157.395 36.9888C157.246 36.9888 157.1 36.9965 156.951 37.0042C156.862 37.008 156.782 37.0962 156.778 37.1881C156.77 37.3376 156.767 37.4832 156.767 37.6327C156.767 38.3188 156.767 39.0048 156.767 39.6908C156.767 39.8212 156.763 39.9515 156.74 40.0779C156.732 40.1201 156.675 40.1661 156.632 40.1853C156.586 40.2083 156.525 40.2121 156.468 40.2121C156.226 40.2159 155.985 40.2159 155.743 40.2121C155.444 40.2083 155.406 40.1623 155.394 39.848C155.391 39.7177 155.394 39.5874 155.394 39.4571C155.394 38.5104 155.394 37.5637 155.394 36.6209C155.391 36.2185 155.391 35.8084 155.391 35.4021ZM158.039 31.9451C157.725 31.9451 157.41 31.9451 157.096 31.9489C157.023 31.9489 156.951 31.9642 156.878 31.9872C156.847 31.9949 156.809 32.0332 156.801 32.0601C156.782 32.1482 156.763 32.2402 156.763 32.3322C156.759 33.3133 156.759 34.2907 156.763 35.2718C156.763 35.3446 156.774 35.4175 156.782 35.4903C156.79 35.5554 156.862 35.6283 156.924 35.6397C156.958 35.6474 156.997 35.6589 157.031 35.6589C157.679 35.6589 158.326 35.6666 158.974 35.6589C159.12 35.6589 159.269 35.6283 159.411 35.5938C159.844 35.4903 160.181 35.2412 160.411 34.8579C160.68 34.4095 160.764 33.9266 160.664 33.4168C160.45 32.3283 159.656 31.9298 158.92 31.9451C158.629 31.9489 158.334 31.9451 158.039 31.9451Z"
          fill="#04D9FF"
        />
        <path
          d="M68.8154 35.3945C68.8154 33.9649 68.8154 32.5392 68.8154 31.1096C68.8154 30.5768 68.8193 30.5768 69.329 30.573C70.314 30.5692 71.2951 30.5768 72.2801 30.573C72.5791 30.573 72.8704 30.6037 73.1616 30.6727C73.9397 30.8566 74.5452 31.2897 74.963 31.9719C75.2696 32.4702 75.4306 33.0182 75.4536 33.6046C75.4727 34.0914 75.4152 34.5628 75.2466 35.0265C74.8672 36.0728 73.9627 36.9275 72.5331 36.985C71.9774 37.008 71.4178 36.9888 70.8621 36.9927C70.6973 36.9927 70.5286 37.0042 70.3638 37.0118C70.2987 37.0157 70.2182 37.0885 70.2143 37.1498C70.2028 37.2801 70.1913 37.4066 70.1913 37.5369C70.1875 38.2038 70.1913 38.8707 70.1913 39.5414C70.1913 39.6909 70.1913 39.8365 70.1837 39.986C70.176 40.1431 70.1032 40.2159 69.9346 40.2159C69.6394 40.2198 69.3405 40.2198 69.0454 40.2121C68.9112 40.2083 68.8308 40.1354 68.8269 40.0128C68.8193 39.848 68.8193 39.6794 68.8193 39.5107C68.8154 38.1386 68.8154 36.7666 68.8154 35.3945ZM70.1913 33.7694C70.1913 34.2332 70.1875 34.6931 70.1913 35.1568C70.1913 35.268 70.2028 35.3791 70.2105 35.4865C70.2143 35.5478 70.2948 35.6321 70.3523 35.6398C70.406 35.6474 70.4635 35.6589 70.5171 35.6589C71.1265 35.6589 71.7397 35.6666 72.3491 35.6589C72.5139 35.6551 72.6826 35.6283 72.8435 35.5899C73.2996 35.4826 73.6446 35.2182 73.8707 34.8081C74.1121 34.375 74.1888 33.9112 74.0968 33.4168C73.9282 32.5277 73.2651 31.9374 72.353 31.9451C71.7436 31.9489 71.1303 31.9451 70.521 31.9489C70.4481 31.9489 70.3715 31.9643 70.3025 31.9834C70.2718 31.9911 70.2335 32.0294 70.2258 32.0601C70.2067 32.1482 70.1913 32.2402 70.1913 32.3322C70.1875 32.8074 70.1913 33.2903 70.1913 33.7694Z"
          fill="#04D9FF"
        />
        <path
          d="M145.414 34.1603C145.414 33.1408 145.414 32.1213 145.414 31.1019C145.414 30.9524 145.422 30.8067 145.429 30.6573C145.433 30.596 145.51 30.5116 145.571 30.5078C145.755 30.4963 145.939 30.4848 146.127 30.4848C146.821 30.481 146.763 30.4618 146.763 31.1172C146.767 33.0258 146.763 34.9383 146.763 36.847C146.763 37.0156 146.763 37.1804 146.767 37.3491C146.778 37.8511 147.008 38.2344 147.411 38.518C147.641 38.679 147.898 38.794 148.166 38.8591C148.794 39.0124 149.415 39.0009 150.025 38.771C150.27 38.679 150.492 38.5487 150.688 38.3685C150.956 38.1194 151.125 37.8166 151.144 37.4449C151.152 37.2609 151.155 37.0731 151.155 36.8892C151.155 34.9958 151.155 33.1063 151.155 31.213C151.155 31.0444 151.159 30.8796 151.163 30.7109C151.167 30.5845 151.251 30.4886 151.366 30.4886C151.68 30.4848 151.999 30.4848 152.313 30.4886C152.432 30.4886 152.512 30.5806 152.52 30.7071C152.524 30.7991 152.527 30.8911 152.527 30.9869C152.527 33.0642 152.527 35.1415 152.527 37.2188C152.527 37.4411 152.512 37.6595 152.47 37.8818C152.363 38.4299 152.106 38.8898 151.707 39.2731C151.213 39.7521 150.615 40.0357 149.956 40.1967C149.063 40.4113 148.185 40.3347 147.334 39.9936C146.936 39.8326 146.572 39.6142 146.257 39.3152C145.736 38.8208 145.441 38.2229 145.422 37.4947C145.414 37.2341 145.414 36.9773 145.414 36.7167C145.414 35.8658 145.414 35.0112 145.414 34.1603Z"
          fill="#04D9FF"
        />
        <path
          d="M98.0049 40.1968C97.9206 39.986 97.8478 39.8135 97.7788 39.641C97.614 39.208 97.453 38.7749 97.2882 38.3418C97.2345 38.2038 97.177 38.0658 97.1196 37.9317C97.0812 37.8397 97.0084 37.786 96.9088 37.7784C96.8359 37.7745 96.7593 37.7669 96.6865 37.7669C95.6287 37.7669 94.5708 37.7669 93.513 37.7669C93.4211 37.7669 93.3291 37.7745 93.2371 37.7822C93.1604 37.7899 93.0953 37.832 93.0646 37.9049C92.9956 38.0582 92.9305 38.2115 92.8692 38.3648C92.6737 38.8669 92.4859 39.3689 92.2904 39.8672C92.2559 39.9515 92.2214 40.0396 92.1716 40.1163C92.1448 40.1585 92.0873 40.2006 92.0413 40.2006C91.6542 40.2044 91.2633 40.2044 90.8762 40.2006C90.8072 40.2006 90.7612 40.1125 90.788 40.032C90.8455 39.8748 90.903 39.7177 90.9643 39.5644C91.5699 38.0313 92.1793 36.4983 92.7848 34.9652C93.2984 33.6736 93.8082 32.382 94.3256 31.0904C94.3945 30.918 94.4674 30.7493 94.544 30.5807C94.5747 30.5079 94.6398 30.4657 94.7203 30.4657C94.9618 30.4619 95.2032 30.4657 95.4409 30.4695C95.5213 30.4695 95.5788 30.5232 95.6133 30.5922C95.6708 30.711 95.7168 30.8298 95.7666 30.9486C96.9203 33.8614 98.0777 36.7704 99.2313 39.6832C99.285 39.8212 99.331 39.963 99.3731 40.101C99.3808 40.124 99.3425 40.1623 99.3233 40.1891C99.3118 40.2006 99.2888 40.2083 99.2735 40.2083C98.8557 40.2236 98.4495 40.2313 98.0049 40.1968ZM95.0576 36.4791C95.0576 36.4829 95.0576 36.4868 95.0576 36.4906C95.4102 36.4906 95.7628 36.4906 96.1154 36.4906C96.1882 36.4906 96.2649 36.4829 96.3377 36.4791C96.4488 36.4715 96.514 36.3871 96.4795 36.2951C96.3684 35.9809 96.2534 35.6666 96.1384 35.3562C95.8586 34.6088 95.575 33.8653 95.2875 33.1217C95.2492 33.0182 95.1917 32.9224 95.1342 32.8304C95.1227 32.8151 95.0499 32.8151 95.0384 32.8304C94.9886 32.9071 94.9388 32.9837 94.9081 33.0719C94.521 34.076 94.1378 35.0802 93.7545 36.0844C93.743 36.1188 93.7315 36.1533 93.72 36.1917C93.7085 36.2262 93.7008 36.2645 93.6932 36.299C93.6663 36.3948 93.7315 36.4868 93.8388 36.4868C94.2412 36.4829 94.6513 36.4791 95.0576 36.4791Z"
          fill="#04D9FF"
        />
        <path
          d="M63.1467 30.4734C63.2195 30.642 63.2808 30.7762 63.3345 30.9103C64.4957 33.8384 65.6609 36.7666 66.8222 39.6947C66.8567 39.779 66.8912 39.8672 66.9218 39.9553C66.9908 40.147 66.9563 40.2083 66.7762 40.2121C66.4427 40.2159 66.1093 40.2159 65.7758 40.2121C65.7222 40.2121 65.6685 40.1891 65.6187 40.1776C65.4884 40.0281 65.4462 39.8442 65.3811 39.6717C65.1971 39.2041 65.0285 38.7365 64.8522 38.269C64.8177 38.1808 64.787 38.0965 64.7525 38.0083C64.695 37.855 64.5954 37.7631 64.4191 37.7669C64.3271 37.7707 64.2351 37.7631 64.1393 37.7631C63.1543 37.7631 62.1732 37.7631 61.1882 37.7631C61.0234 37.7631 60.8547 37.7362 60.6784 37.8359C60.6286 37.9547 60.5635 38.0888 60.5098 38.223C60.3028 38.7595 60.0959 39.2961 59.8889 39.8288C59.8429 39.9477 59.7816 40.0626 59.7241 40.1853C59.2719 40.2236 58.8273 40.2274 58.3789 40.1814C58.3789 40.1125 58.3635 40.055 58.3827 40.009C58.4478 39.8173 58.5207 39.6257 58.5973 39.4379C59.6896 36.6823 60.7857 33.9266 61.8781 31.1709C61.8934 31.1364 61.9049 31.1019 61.9164 31.0674C62.2115 30.3584 62.0659 30.4542 62.8247 30.4465C62.9129 30.4542 63.0048 30.4657 63.1467 30.4734ZM62.6522 36.4945C62.9665 36.4945 63.2846 36.4945 63.5989 36.4945C63.7101 36.4945 63.8212 36.4868 63.9323 36.4791C64.0358 36.4715 64.0972 36.3833 64.0665 36.2875C64.0397 36.1993 64.0128 36.1112 63.9822 36.023C63.6142 35.0534 63.2463 34.0837 62.8745 33.1141C62.84 33.0259 62.8017 32.9416 62.7557 32.8649C62.7442 32.8419 62.6982 32.8228 62.6676 32.8266C62.6369 32.8304 62.5986 32.8534 62.5794 32.8803C62.5488 32.9263 62.5296 32.9799 62.5066 33.0297C62.1157 34.0492 61.7247 35.0725 61.3338 36.092C61.3223 36.1265 61.3108 36.161 61.2993 36.1993C61.2342 36.4025 61.284 36.4868 61.4833 36.4945C61.5944 36.4983 61.7056 36.4983 61.8167 36.4983C62.0965 36.4945 62.3763 36.4945 62.6522 36.4945Z"
          fill="#04D9FF"
        />
        <path
          d="M79.566 40.2198C78.9336 40.2198 78.305 40.2198 77.6727 40.2198C77.5424 40.2198 77.412 40.2083 77.2856 40.2006C77.2204 40.1968 77.1476 40.124 77.1438 40.0511C77.1399 39.756 77.1361 39.4609 77.1399 39.1658C77.1399 39.0738 77.2242 38.9933 77.3201 38.9895C77.4695 38.9818 77.6152 38.9742 77.7646 38.9703C78.0253 38.9665 78.2859 38.9703 78.5427 38.9665C78.8531 38.9588 78.9068 38.9052 78.9144 38.6177C78.9183 38.5258 78.9183 38.4338 78.9183 38.338C78.9183 36.3527 78.9183 34.3712 78.9183 32.3859C78.9183 32.2364 78.9144 32.0908 78.9029 31.9413C78.8953 31.8225 78.811 31.742 78.6806 31.7382C78.3855 31.7305 78.0866 31.7305 77.7915 31.7267C77.6267 31.7228 77.458 31.7152 77.2932 31.7075C77.2242 31.7037 77.1514 31.6308 77.1438 31.5657C77.1399 31.5274 77.1323 31.4929 77.1284 31.4545C77.1246 31.4009 77.1246 31.3434 77.1246 31.2859C77.1323 30.3967 77.0249 30.4734 77.9218 30.4734C79.0716 30.4696 80.2214 30.4734 81.3712 30.4734C81.536 30.4734 81.7046 30.481 81.8694 30.4925C81.946 30.4964 82.0189 30.5615 82.0265 30.6267C82.0649 30.941 82.061 31.2552 82.0304 31.5695C82.0227 31.6385 81.9537 31.7037 81.8809 31.7113C81.7889 31.719 81.6969 31.7267 81.6049 31.7267C81.3098 31.7305 81.0109 31.7267 80.7158 31.7305C80.2827 31.7343 80.2635 31.7573 80.2559 32.2172C80.2559 32.2747 80.2559 32.3284 80.2559 32.3859C80.2559 34.3712 80.2559 36.3527 80.2559 38.338C80.2559 38.4683 80.2559 38.5986 80.2635 38.7251C80.2712 38.8669 80.321 38.9473 80.5126 38.9627C80.6046 38.9703 80.6966 38.9703 80.7924 38.9742C80.9764 38.9742 81.1642 38.9742 81.3482 38.9742C82.107 38.978 82.0495 38.932 82.0534 39.6602C82.0534 39.7905 82.0457 39.9208 82.038 40.0473C82.0304 40.1431 81.9537 40.2083 81.8502 40.2121C81.7008 40.2198 81.5551 40.2198 81.4056 40.2236C80.7886 40.2198 80.1754 40.2198 79.566 40.2198Z"
          fill="#04D9FF"
        />
        <path
          d="M86.7905 36C86.7905 34.831 86.7905 33.662 86.7905 32.4969C86.7905 32.3283 86.7867 32.1635 86.779 31.9987C86.7713 31.8722 86.6909 31.7879 86.5721 31.7802C86.4226 31.7726 86.2769 31.7687 86.1275 31.7687C85.5142 31.7687 84.901 31.7687 84.2916 31.7649C84.1805 31.7649 84.0693 31.7496 83.962 31.7304C83.9314 31.7266 83.9045 31.6844 83.8815 31.6576C83.87 31.6461 83.87 31.6231 83.87 31.6039C83.87 31.2896 83.8662 30.9754 83.8662 30.6611C83.8662 30.5806 83.9659 30.4963 84.0578 30.4925C84.2073 30.4848 84.353 30.481 84.5024 30.481C85.5602 30.481 86.618 30.481 87.6759 30.481C88.6033 30.481 89.5309 30.481 90.4584 30.481C90.6078 30.481 90.7535 30.4925 90.9029 30.504C90.9681 30.5078 91.0409 30.5883 91.0486 30.6496C91.0524 30.6688 91.0562 30.6879 91.0562 30.7033C91.0562 30.983 91.0601 31.259 91.0562 31.5388C91.0524 31.6921 90.9796 31.7572 90.8033 31.7611C90.6538 31.7649 90.5082 31.7649 90.3587 31.7649C89.803 31.7649 89.2472 31.7649 88.6877 31.7649C88.5765 31.7649 88.4654 31.7687 88.3542 31.7764C88.2584 31.7841 88.1741 31.8607 88.1626 31.945C88.1549 31.9987 88.1473 32.0562 88.1473 32.1098C88.1434 32.2785 88.1434 32.4433 88.1434 32.6119C88.1434 34.8923 88.1434 37.1727 88.1434 39.4532C88.1434 39.6218 88.1434 39.7866 88.1396 39.9552C88.1358 40.1315 88.0706 40.2044 87.9173 40.2082C87.603 40.2082 87.2888 40.2044 86.9706 40.1967C86.9055 40.1967 86.8288 40.12 86.8212 40.0549C86.8097 39.8901 86.7943 39.7215 86.7943 39.5566C86.7905 38.3724 86.7905 37.1881 86.7905 36Z"
          fill="#04D9FF"
        />
        <path
          d="M101.231 35.3715C101.231 33.9457 101.231 32.52 101.231 31.0942C101.231 30.5768 101.235 30.573 101.753 30.573C101.937 30.573 102.124 30.573 102.308 30.5768C102.488 30.5807 102.565 30.6612 102.573 30.8566C102.58 31.0406 102.58 31.2284 102.58 31.4123C102.58 33.6353 102.58 35.8582 102.58 38.0811C102.58 38.2843 102.592 38.4874 102.6 38.6905C102.603 38.7787 102.692 38.863 102.784 38.8668C102.948 38.8745 103.117 38.8822 103.282 38.8822C104.32 38.8822 105.359 38.8822 106.394 38.8822C106.563 38.8822 106.727 38.886 106.896 38.8898C107.022 38.8937 107.114 38.9741 107.118 39.0891C107.122 39.3842 107.126 39.6832 107.122 39.9783C107.118 40.1354 107.038 40.2044 106.873 40.2121C106.781 40.2159 106.689 40.2159 106.593 40.2159C104.98 40.2159 103.366 40.2159 101.756 40.2159C101.235 40.2159 101.224 40.2274 101.224 39.7023C101.231 38.2613 101.231 36.8164 101.231 35.3715Z"
          fill="#04D9FF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2477_11198">
        <rect width="162" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_2477_11198">
        <rect width="162.033" height="48" fill="white" />
      </clipPath>
    </defs>
  </>
);

const NewCheckout = ({ anonymous, removeCoupon, isPublic }) => {
  const [selectedAmountBox, setSelectedAmountBox] = useState(0); // active purpose only
  const [selectedAmountFree, setSelectedAmountFree] = useState(0); // active purpose only
  const [selectedPlatformBox, setSelectedPlatformBox] = useState(0); // active purpose only
  const [selectedAcType, setSelectedAcType] = useState(1); // active purpose only
  const [selectedOrderBox, setSelectedOrderBox] = useState(0);
  const [isCoindMethodSelected, setIsCoinMethodSelected] = useState(false);
  const [useEA, setUseEA] = useState(0); // active purpose only
  const [selectedType, setSelectedtype] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState("50");
  const [platformVal, setPlatformVal] = useState();
  const [isThisPublicCheckout, setIsThisPublicCheckout] = useState();
  const acc_balance = [
    "$5,000.00",
    "$10,000.00",
    "$50,000.00",
    "$100,000.00",
    "$150,000.00",
    "$200,000.00",
  ];

  console.log(selectedPrice, "selectedPlatformBox");

  // -------------------------------------------------
  const [data, setData] = useState({
    email: "",
    firstName: "",
    lastName: "",
  });

  const updateData = (k, v) =>
    setData((prevState) => ({ ...prevState, [k]: v }));

  const challenges = useSelector((state) => state.payments.challenges);
  const userProfile = useSelector((state) => state.user);

  const ACCtoken = useSelector((state) => state.ACCtoken);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  // const userAmount = challenges["Alpha Pro"]?.filter(
  //   (item) => String(item.id) === id
  // );

  const [accountBalance, setAccountBalance] = useState(false);
  const [countryCode, setCountryCode] = useState(null);
  const [fundingEval, setFundingEval] = useState(false);
  const [FreeTrial, setFreeTrial] = useState(false);
  const [basicDetails, setBasicDetails] = useState(false);
  const [coupon, setCoupon] = useState({
    value: "",
    error: "",
    loading: false,
  });
  const [EAs, setEAs] = useState(false);
  const [showTNC, setShowTNC] = useState(false);
  const [TNC, setTNC] = useState(false);
  const [checkout, setCheckout] = useState({
    price: 0,
    discount: 0,
    final_price: 0,
  });

  const [initialPlan, setInitialPlan] = useState();

  useEffect(() => {
    if (challenges) {
      setInitialPlan(
        challenges["Alpha Pro"]?.find((item) => item?.id === Number(id))?.Price
      );
    }
  }, []);

  useEffect(() => {
    updateData("challenge_id", Number(id));
    updateData("challenge", Number(id));
    setSelectedPrice(initialPlan);
  }, [id]);

  // Popup states
  const [showPopup, setShowPopup] = useState(false);
  const [combinedPUHead, setCombinedPUHead] = useState("");
  const [combinedPUBody, setCombinedPUBody] = useState("");
  const [popUpType, setPopUpType] = useState("");

  // Auth
  const isLogged = useSelector((state) => state.isLogged);
  const isACCtoken = useAuth();

  const params = useParams();

  function addMetaScripts() {
    const meta_noscript = document.createElement("noscript");
    const img = document.createElement("img");
    img.height = "1";
    img.width = "1";
    img.alt = "";
    img.style = "display:none";
    img.src =
      "https://www.facebook.com/tr?id=651339132566810&ev=PageView&noscript=1";
    meta_noscript.appendChild(img);

    document.body.appendChild(meta_noscript);
  }

  function addGoogleTagScripts() {
    const script1 = document.createElement("script");
    script1.src =
      "https://www.googletagmanager.com/gtag/js?id=AW-11028943102%22%3E";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.textContent = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-11028943102');`;
    document.body.appendChild(script2);
  }

  const [paymentMethod, setPaymentMethod] = useState("nuvei");
  const [openCryptoOptionsBD, setOpenCryptoOptionsBD] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("ETH");
  console.log(selectedCrypto, "crypto");
  const radioGroupRef = React.useRef(null);

  function handlePaymentMethod(e) {
    const id = e.currentTarget.id;
    setPaymentMethod(id);
    if (id === "coinspayment") {
      setOpenCryptoOptionsBD(true);
    }
  }

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (!userProfile?.Country && isACCtoken !== 0 && isLogged === true) {
        alert("Please complete your profile");
        navigate("/profile");
        return;
      }
    }, 2000);
    if (!removeCoupon) {
      if (isACCtoken !== 0 && isLogged === true) {
        navigate(`/FundingEvaluationPayment/${params.id}`);
      } else {
        navigate(`/funding-evaluation/checkout/${params.id}`);
      }
    }
    if (removeCoupon && params.code) {
      setCoupon((prevState) => ({
        ...prevState,
        value: params.code,
      }));
    }
  }, [
    isACCtoken,
    isLogged,
    params.id,
    params.code,
    anonymous,
    removeCoupon,
    navigate,
  ]);

  useEffect(() => {
    setConfirmPaymentClick(true);
    setIsLoading(true);
    dispatch(getChallenges())
      .then((res) => {
        setIsLoading(false);
        setConfirmPaymentClick(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setConfirmPaymentClick(false);
      });
    if (!anonymous) {
      setIsLoading(true);
      dispatch(getUserBasicDetails())
        .then((res) => {
          setBasicDetails(res);
          updateData("email", res.email);
          setIsLoading(false);
          setConfirmPaymentClick(false);
          const country_string = String(res.Country).toLowerCase();
          const country = countries.filter(
            (item) =>
              (item.label.toLowerCase() === country_string) |
              (item.code.toLowerCase() === country_string)
          );
          if (country.length === 1) {
            setCountryCode(country[0]);
          }
          setConfirmPaymentClick(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setConfirmPaymentClick(false);
        });
      dispatch(LoadUser());
    }
    addGoogleTagScripts();
    addMetaScripts();
    setTimeout(() => {
      setIsLoading(false);
      setConfirmPaymentClick(false);
    }, 1000);
  }, [dispatch, anonymous]);

  useEffect(() => {
    if (params.id) {
      challenges &&
        Object.keys(challenges).forEach((plan_type) => {
          challenges[plan_type].forEach((challenge) => {
            if (String(challenge.id) === String(params.id)) {
              setFundingEval(
                challenge.plan_type === "Alpha pro"
                  ? "Alpha Pro"
                  : challenge.plan_type
              );
              setAccountBalance(challenge.account_balance);
              updateData("leverage", Number(challenge.leverage));
              updateData("challenge_id", challenge.id);
              updateData("challenge", challenge.id);
              updateData("challenge_name", challenge.name);

              return;
            }
          });
        });
    }
  }, [params.id, challenges, dispatch]);

  useEffect(() => {
    if (fundingEval && accountBalance && challenges) {
      const plan = challenges[fundingEval].filter((challenge) => {
        if (challenge.account_balance === accountBalance) {
          return true;
        }
        return false;
      });

      if (plan.length === 1) {
        updateData("leverage", Number(plan[0].leverage));
        updateData("challenge_id", plan[0].id);
        updateData("challenge", plan[0].id);
      } else {
        updateData("challenge_id", "");
        updateData("challenge", "");
      }
    }
  }, [fundingEval, accountBalance, challenges, selectedPrice]);

  useEffect(() => {
    validateCouponCode();
  }, [data.challenge_id]);

  const [confirmPaymentClick, setConfirmPaymentClick] = useState(false);
  const [isChecked, setIsChecked] = useState({
    tnc: false,
    not_us_resident: false,
    acknowledge_personal_data: false,
    agree_to_news_letters: false,
  });
  const handleTNCModal = (value) => {
    setShowTNC(TNC ? false : value);
  };

  const handleFinalPayment = async (e) => {
    e.preventDefault();
    console.log("=========");
    setConfirmPaymentClick(true);
    if (!data.email) {
      setShowPopup(true);
      setConfirmPaymentClick(false);
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Please enter a valid email address");
      setPopUpType("error");
      return;
    }

    if (
      isChecked.tnc === false ||
      isChecked.acknowledge_personal_data === false ||
      isChecked.not_us_resident === false
    ) {
      setShowPopup(true);
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Please accept the terms and conditions");
      setPopUpType("error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!data.challenge_id) {
      setShowPopup(true);
      setConfirmPaymentClick(false);
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Please select a plan and balance!");
      setPopUpType("error");
      return;
    }

    const acc_creation_payload = {
      name: data.name,
      pwd: data.pwd,
      pwdInvestor: data.pwd,
      group: "ACGd\\demo ACG",
      leverage: data.leverage,
      challenge: data.challenge,
    };
    const freetrial_acc_payload = {
      challenge: data.challenge,
      raw_spread: selectedAcType === 0,
    };
    const country_code = (countryCode && countryCode.code) || "";
    const payload = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      country_code,
      challenge_id: data.challenge_id,
      payment_method: paymentMethod,
      cryptocurrency: selectedCrypto,
      success_url: `${window.location.origin}/an/funding-evaluation/payment/success/`,
      cancel_url: `${window.location.origin}/an/funding-evaluation/payment/fail/`,
      account_balance: accountBalance,
      EAs: useEA,
      raw_spread: selectedAcType === 0,
      platform:
        selectedPlatformBox === 0
          ? "mt5"
          : selectedPlatformBox === 1
          ? "ctrader"
          : selectedPlatformBox === 2
          ? "matchtrade"
          : null,
    };
    if (coupon.value && !coupon.loading) payload["coupon"] = coupon.value;

    if (
      isChecked.tnc === false ||
      isChecked.acknowledge_personal_data === false ||
      isChecked.not_us_resident === false
    ) {
      alert("Please agree to Terms and Conditions");
      setConfirmPaymentClick(false);
      return;
    }

    if (FreeTrial) {
      if (freetrial_acc_payload) {
        setShowPopup(true);
        setCombinedPUHead("Creating Account");
        setCombinedPUBody("Please wait...");
        setPopUpType("success");
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        config.headers[
          "x-api-key"
        ] = `ONRzS8gkWBRkr76XYyI6z1e6p6NX72x83KABC4dpx90sSxgzF9n3QqlQoBHGvGZKgu3a2hVPVtMeUYxlyILZMK5cZo2VspEKWORYvdN4fk1WVmtALKKlfwAFFXRpBFyIGQOcNHRtn0dsr6YJhhdNXrDh4Fk5dlt4Cns2CPl5e7QgByxNaSpfJE6vewJVsgmp6KMMWnnOqyMmBWw33NQyTbdP0gCwaLHPlspCEWJDokCUFSVf0IwG8hWJkulr5Al`;
        config.headers["AUTHORIZATION"] = ACCtoken;
        // return
        axiosInstance
          .post("v2/create/free-trial/", freetrial_acc_payload, config)
          .then((res) => {
            if (res.data.success) {
              setShowPopup(true);
              setCombinedPUHead("Woo hoo !");
              setCombinedPUBody("Account created successfully!!");
              setPopUpType("success");
              dispatch(deletePaymentIntent());

              if (res.auth) {
                dispatch(AcctokenD(res.auth.idToken));
                dispatch(RefftokenD(res.auth.refresh_token));

                dispatch(login());
              }
              dispatch(getUserProfile()).then((data) => {
                dispatch(addCurrentAccount({ login_id: res.data.login }));
                navigate("/AccountMetric");
              });
            }
          })
          .catch((error) => {
            console.log({ ...error });
            setConfirmPaymentClick(false);
            if (error.response.data?.detail) {
              setShowPopup(true);
              setCombinedPUHead("Oh snap!");
              setCombinedPUBody(error.detail);
              setPopUpType("error");
            } else if (error.response.data.message) {
              setShowPopup(true);
              setCombinedPUHead("Oh snap!");
              setCombinedPUBody(error.response.data.message);
              setPopUpType("error");
            } else {
              setShowPopup(true);
              setCombinedPUHead("Oh snap!");
              setCombinedPUBody("Something went wrong");
              setPopUpType("error");
            }
          });
      }
    } else {
      acc_creation_payload["EAs"] = useEA;
      acc_creation_payload["raw_spread"] = selectedAcType === 0;
      acc_creation_payload["email"] = data.email;
      acc_creation_payload["platform"] =
        selectedPlatformBox === 0 ? "mt5" : "ctrader";

      acc_creation_payload["agreed_to"] = [];
      isChecked.tnc &&
        acc_creation_payload["agreed_to"].push(
          "I declare that I have read and agree withTerms & Conditions , Privacy policy , General Service Aggrement.*"
        );
      isChecked.not_us_resident &&
        acc_creation_payload["agreed_to"].push(
          "I'm not a US resident or citizen.*"
        );
      isChecked.acknowledge_personal_data &&
        acc_creation_payload["agreed_to"].push(
          "I acknowledge that signing up with personal details that do not match my ID/Password information, will lead to suspension of my payout(s) and closure of my account(s).*"
        );
      isChecked.agree_to_news_letters &&
        acc_creation_payload["agreed_to"].push(
          "I agree to receive news letters, news and product updates."
        );

      acc_creation_payload["country_code"] = country_code;
      // return

      dispatch(stripePaymentInitV4(payload, acc_creation_payload))
        .then((res) => {
          // console.log(res);
          // 1. Login
          // 2. Redirect to payment link
          if (res.auth) {
            // New user auto login
            dispatch(AcctokenD(res.auth.idToken));
            dispatch(RefftokenD(res.auth.refresh_token));
            dispatch(sessionTimeout(false));

            dispatch(getUserProfile())
              .then((data) => {})
              .catch((error) => {});
            dispatch(login());
          }

          window.location.href = res.url;
        })
        .catch((error) => {
          // dispatch(LoadUser())
          setCoupon((prevState) => ({ ...prevState, loading: true }));
          setConfirmPaymentClick(false);
          if (error?.detail) {
            setShowPopup(true);
            setCombinedPUHead("Oh snap!");
            setCombinedPUBody(error.detail);
            setPopUpType("error");
          }
          if (error?.message) {
            setShowPopup(true);
            setCombinedPUHead("Oh snap!");
            setCombinedPUBody(error.message);
            setPopUpType("error");
          }
          if (
            error?.code === "email_exists" ||
            error?.code === "session_timeout"
          ) {
            dispatch(LoadUser());
            dispatch(sessionTimeout(true));
            navigate("/login");
          }
        });
    }
  };

  const validateCouponCode = () => {
    setCoupon((prevState) => ({ ...prevState, loading: true }));
    if (!data.challenge_id) return;
    const coupon_code = coupon.value ? coupon.value : null;

    dispatch(applyCouponCode(data.challenge_id, coupon_code))
      .then((res) => {
        setCoupon((prevState) => ({ ...prevState, error: "" }));
        setCoupon((prevState) => ({ ...prevState, loading: false }));
        setCheckout((prev) => ({
          price: res.actual_price,
          discount: coupon.error ? 0 : res.discount,
          final_price: coupon.error ? res.actual_price : res.discounted_price,
        }));
        setFreeTrial(res.discounted_price === 0);
        if (res.data.coupon) setCoupon(res.data.coupon);
      })
      .catch((error) => {
        // setCoupon(prevState=>({...prevState, loading:false}));
        setCoupon((prevState) => ({
          ...prevState,
          error: error?.detail,
          loading: false,
        }));
      });
  };

  useEffect(() => {
    if (showTNC) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.removeAttribute("style");
    }
  }, [showTNC]);
  //--------------------------------------------------

  const platform = [metaTrader, cTrader];
  const ac_type = ["Raw spread", "No commission"];
  const EA = ["Yes", "No"];
  const OrderConfirmation = [coinPayment, coinPayment];

  useEffect(() => {
    if (isCoindMethodSelected) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isCoindMethodSelected]);

  useEffect(() => {
    if (FreeTrial || fundingEval === "Free Trial") {
      setSelectedPlatformBox(0);
      setPlatformVal(platform[0]);
    }
  }, [FreeTrial, fundingEval, platform]);

  return (
    <div className="checkoutNew_container">
      <CombinedPopup
        type={popUpType}
        trigger={showPopup}
        setTrigger={setShowPopup}
        head={combinedPUHead}
        subhead={combinedPUBody}
      />

      {showTNC ? (
        <TNCModal showTNC={showTNC} onTNC={(value) => handleTNCModal(value)} />
      ) : (
        <></>
      )}

      {anonymous ? (
        <div
          className="account_balance"
          style={{ display: "flex", justifyContent: "start", border: "none" }}
        >
          <LogoIcon
            viewBox="0 0 162 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ width: "162px", height: "48px", justifySelf: "left" }}
          />
        </div>
      ) : (
        false
      )}
      <div className="account_balance">
        <div className="heading">
          <div
            onClick={() => {
              navigate("/FundingEvaluation");
            }}
            className="crossBTN"
          >
            X
          </div>
          <div>
            <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              Account balance <img src={info_icon} alt="" />
            </h1>
            <p>Select your initial starting capital.</p>
          </div>
          <div className="user_ac_type">
            {challenges &&
              Object.keys(challenges).map((challenge, i) => {
                // Check if it's a public checkout page

                if (isPublic && challenge === "Free Trial") {
                  return null;
                }
                return (
                  <label
                    htmlFor={challenge}
                    key={i}
                    className={
                      fundingEval === challenge
                        ? "ac_type_option selectedtype"
                        : "ac_type_option"
                    }
                    style={{
                      border:
                        fundingEval === challenge
                          ? "1px solid #1395DC"
                          : "1px solid rgb(255 255 255 / 34%)",
                    }}
                    onClick={() => setSelectedtype(i)}
                  >
                    <p>{challenge}</p>
                    <input
                      type="radio"
                      id={challenge}
                      name="fundingEval"
                      value={challenge}
                      checked={fundingEval === challenge}
                      onChange={(e) =>
                        setFundingEval(
                          e.target.value === "Alpha pro"
                            ? "Alpha Pro"
                            : e.target.value
                        )
                      }
                      disabled={removeCoupon}
                    />
                  </label>
                );
              })}
          </div>
        </div>
        {fundingEval === "Alpha Pro" && (
          <div className="amount_list">
            {challenges &&
              typeof challenges === "object" &&
              "Alpha Pro" in challenges &&
              challenges["Alpha Pro"]?.map((balance, index) => {
                console.log(balance, "item");
                return (
                  <label
                    htmlFor={balance.amount}
                    className={
                      selectedPrice === balance?.Price ||
                      data?.challenge_id === balance?.id
                        ? "amount_box selected_box"
                        : "amount_box"
                    }
                    style={{
                      border:
                        selectedPrice === balance?.Price ||
                        data?.challenge_id === balance?.id
                          ? "1px solid #1395DC"
                          : "1px solid  rgb(255 255 255 / 34%)",
                    }}
                  >
                    <input
                      type="radio"
                      name="accoun_balance_value"
                      id={balance.amount}
                      onClick={(e) => {
                        setSelectedAmountBox(e.target.checked ? index : null);
                        setSelectedPrice(balance.Price);
                      }}
                      onChange={(e) =>
                        setAccountBalance(balance.account_balance)
                      }
                      value={accountBalance}
                      style={{ display: "none" }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "90px",
                      }}
                    >
                      <p>{balance.name}</p>
                      <p
                        className={
                          selectedPrice === balance.Price ||
                          data?.challenge_id === balance?.id
                            ? "active_amount_value"
                            : ""
                        }
                      >
                        {index === selectedAmountBox
                          ? dollarUS(balance.Price)
                          : dollarUS(balance.Price)}
                      </p>
                    </div>
                  </label>
                );
              })}
          </div>
        )}
        {fundingEval === "Free Trial" && !isPublic && (
          <div className="amount_list">
            {challenges["Free Trial"]?.map((balance, index) => {
              return (
                <label
                  htmlFor={balance.amount}
                  className={
                    selectedAmountFree === index
                      ? "amount_box selected_box"
                      : "amount_box"
                  }
                  style={{
                    border:
                      selectedAmountFree === index
                        ? "1px solid #1395DC"
                        : "1px solid  rgb(255 255 255 / 34%)",
                  }}
                >
                  <input
                    type="radio"
                    name="accoun_balance_value"
                    id={balance.amount}
                    onClick={(e) => {
                      setSelectedAmountFree(e.target.checked ? index : null);
                      setSelectedPrice(balance.amount);
                    }}
                    onChange={(e) => setAccountBalance(balance.account_balance)}
                    value={accountBalance}
                    style={{ display: "none" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "90px",
                    }}
                  >
                    <p>{balance.name}</p>
                    <p
                      className={
                        selectedAmountFree === index
                          ? "active_amount_value"
                          : ""
                      }
                    >
                      {index === selectedAmountFree
                        ? dollarUS(balance.Price)
                        : dollarUS(balance.Price)}
                    </p>
                  </div>
                </label>
              );
            })}
          </div>
        )}
      </div>
      <div className="other_details">
        <div className="platform">
          <div className="heading">
            <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              Platform <img src={info_icon} alt="" />
            </h1>
            <p style={{ marginBottom: "35px" }}>
              Please select your trading platform.
            </p>
          </div>
          {platform?.map((platform, index) => {
            return (
              <label
                htmlFor={index}
                className={
                  index === selectedPlatformBox
                    ? "platform_box selected_box"
                    : "platform_box"
                }
                onClick={(e) => {
                  if (
                    (FreeTrial || fundingEval === "Free Trial") &&
                    index === 1
                  )
                    return;
                  setSelectedPlatformBox(index);
                  setPlatformVal(platform);
                }}
                style={{
                  border:
                    index === selectedPlatformBox
                      ? "1px solid #1395DC"
                      : "1px solid rgba(255, 255, 255, 0.09)",
                }}
              >
                <img
                  src={platform}
                  alt=""
                  style={{
                    filter:
                      index === 1 && (FreeTrial || fundingEval === "Free Trial")
                        ? "blur(3px)"
                        : "",
                  }}
                />
                {/* {index === 2 ? (
                  <div style={{display:'flex',alignItems:'center',gap:'10px'}} disabled>
                    <img src={matchTrade} width='60px' style={{borderRadius:'50%'}}  alt="" />
                    <h5>MatchTrader</h5>
                  </div>
                  
                ) : (
                  <img
                    src={platform}
                    alt=""
                    style={{
                      filter:
                        index === 1 &&
                        (FreeTrial || fundingEval === "Free Trial")
                          ? "blur(3px)"
                          : "",
                    }}
                  />
                )} */}
                <input
                  type="radio"
                  name="platform_type"
                  id={index}
                  checked={selectedPlatformBox === index}
                  disabled={
                    index === 1 && (FreeTrial || fundingEval === "Free Trial")
                  }
                  style={{
                    filter:
                      index === 1 && (FreeTrial || fundingEval === "Free Trial")
                        ? "blur(3px)"
                        : "",
                  }}
                />
              </label>
            );
          })}
        </div>
        <div className="platform">
          <div className="heading">
            <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              Account type <img src={info_icon} alt="" />
            </h1>
            <p>Choose between Raw spreads and No commission.</p>
          </div>
          {ac_type?.map((type, index) => {
            return (
              <label
                htmlFor={type}
                onClick={(e) => {
                  setSelectedAcType(index);
                }}
                className={
                  selectedAcType === index
                    ? "platform_box selected_box"
                    : "platform_box"
                }
                style={{
                  border:
                    selectedAcType === index
                      ? "1px solid #1395DC"
                      : "1px solid rgba(255, 255, 255, 0.09)",
                }}
              >
                <p style={{ marginTop: "15px" }}>{type}</p>
                <input
                  type="radio"
                  name="platform"
                  id={type}
                  checked={selectedAcType === index}
                  // disabled
                />
              </label>
            );
          })}
        </div>
        <div className="platform">
          <div className="heading">
            <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              EA use <img src={info_icon} alt="" />
            </h1>
            <p style={{ marginBottom: "35px" }}>Do you want to use EA?.</p>
          </div>

          <div
            onClick={(e) => {
              setUseEA(true);
            }}
            className={useEA ? "platform_box selected_box" : "platform_box"}
            style={{
              border: useEA
                ? "1px solid #1395DC"
                : "1px solid rgba(255, 255, 255, 0.09)",
            }}
          >
            Yes
            <div className="outerC">
              <div className="inerC"></div>
            </div>
          </div>

          <div
            onClick={(e) => {
              setUseEA(false);
            }}
            className={"platform_box " + (!useEA && "selected_box")}
            style={{
              border: !useEA
                ? "1px solid #1395DC"
                : "1px solid rgba(255, 255, 255, 0.09)",
            }}
          >
            No
            <div className="outerC">
              <div className="inerC"></div>
            </div>
          </div>
          {/* {EA?.map((EA_text, index) => {
            return (
              <label
                htmlFor={EA_text + index}
                className={
                  useEA === index ? "platform_box selected_box" : "platform_box"
                }
              >
                <p>{EA_text}</p>
                <input
                  type="radio"
                  name="EA"
                  id={EA_text + index}
                  onClick={(e) => {
                    setUseEA(e.target.checked ? index : null);
                  }}
                  // disabled={index === 0}
                />
              </label>
            );
          })} */}
        </div>
      </div>

      <div className="customer_inforamtion">
        <div className="inform">
          <h1>Customer Information</h1>
          <input
            size="small"
            placeholder="First Name *"
            fullWidth
            style={{
              border: "1px solid rgb(255 255 255 / 33%);",
              borderRadius: "10px",
              background: "none !important",
            }}
            value={basicDetails ? basicDetails.first_name : ""}
            onChange={(e) =>
              setBasicDetails({ ...basicDetails, first_name: e.target.value })
            }
          />
          <input
            size="small"
            placeholder="Last Name *"
            fullWidth
            style={{
              border: "1px solid rgb(255 255 255 / 33%);",
              borderRadius: "10px",
              background: "transparent",
            }}
            value={basicDetails ? basicDetails.last_name : ""}
            onChange={(e) =>
              setBasicDetails({
                ...basicDetails,
                last_name: e.target.value,
              })
            }
          />
          <input
            size="small"
            placeholder="Email *"
            fullWidth
            style={{
              border: "1px solid rgb(255 255 255 / 33%);",
              borderRadius: "10px",
              background: "transparent",
            }}
            defaultValue={basicDetails ? basicDetails.email : ""}
            value={data.email}
            onChange={(e) => updateData("email", e.target.value)}
          />
        </div>
        <div className="discount">
          <h1>Apply Code</h1>
          {!removeCoupon && (
            <div className="couponLine">
              <div className="inputHolder discount_input">
                <input
                  className="discount_input"
                  placeholder="Discount Code"
                  type="text"
                  value={coupon.value}
                  // disabled={Number(checkout.final_price) === 0 ? true : false}
                  onBlur={(e) => validateCouponCode()}
                  onChange={(e) =>
                    setCoupon((prevState) => ({
                      ...prevState,
                      value: e.target.value,
                    }))
                  }
                  style={coupon.error ? { border: "2px solid #fd2d2d" } : {}}
                />
                {coupon.error ? (
                  <small
                    style={
                      coupon.error
                        ? {
                            color: "#fd2d2d",
                            textAlign: "left",
                            float: "left",
                          }
                        : {}
                    }
                  >
                    Invalid coupon
                  </small>
                ) : (
                  false
                )}
                <button
                  onClick={coupon?.value !== "" ? validateCouponCode : null}
                  className={showTNC ? "nozIndex" : "zIndex"}
                >
                  Apply
                </button>
              </div>
            </div>
          )}
          <div className="calculate_price_with_discount">
            <div>
              <p>Total</p>
              {/* <p>${dollarUS(accountBalance)}</p> */}
              <p>${Number(checkout.price).toFixed(2)} </p>
            </div>
            {!removeCoupon && (
              <>
                {checkout.discount &&
                checkout.discount !== 0 &&
                !coupon.error ? (
                  <div>
                    <p>Discount</p>
                    <p style={{ color: !coupon.error ? "#ff5151" : "" }}>
                      {" "}
                      {coupon.error ? "" : "-"} $ {checkout.discount}
                    </p>
                  </div>
                ) : null}
              </>
            )}
            <div>
              <p>Final Price</p>
              <p>
                ${" "}
                {coupon.error
                  ? Number(checkout.price).toFixed(2)
                  : Number(checkout.final_price).toFixed(2)}
              </p>
            </div>
          </div>
          <span>By confirming the order:</span>
          <div className="TandC">
            <input
              type="checkbox"
              value={isChecked.tnc}
              onChange={(e) =>
                setIsChecked({ ...isChecked, tnc: e.target.checked })
              }
              style={{ marginTop: "3px" }}
            />

            <p>
              I declare that I have read and agree with
              <span
                onClick={() => setShowTNC(true)}
                style={{ color: "#1f69ff", cursor: "pointer" }}
              >
                Terms & Conditions , Privacy policy , General Service
                Aggrement.*
              </span>
            </p>
          </div>

          <div className="TandC">
            <input
              type="checkbox"
              value={isChecked.not_us_resident}
              onChange={(e) =>
                setIsChecked({
                  ...isChecked,
                  not_us_resident: e.target.checked,
                })
              }
              style={{ marginTop: "3px" }}
            />

            <p>I'm not a US resident or citizen.*</p>
          </div>

          <div className="TandC">
            <input
              type="checkbox"
              value={isChecked.acknowledge_personal_data}
              onChange={(e) =>
                setIsChecked({
                  ...isChecked,
                  acknowledge_personal_data: e.target.checked,
                })
              }
              style={{ marginTop: "3px" }}
            />

            <p>
              I acknowledge that signing up with personal details that do not
              match my ID/Password information, will lead to suspension of my
              payout(s) and closure of my account(s).*
            </p>
          </div>

          <div className="TandC">
            <input
              type="checkbox"
              value={isChecked.agree_to_news_letters}
              onChange={(e) =>
                setIsChecked({
                  ...isChecked,
                  agree_to_news_letters: e.target.checked,
                })
              }
              style={{ marginTop: "3px" }}
            />
            <p>I agree to receive news letters, news and product updates.</p>
          </div>

          <CustomLoadingButton
            disabled={confirmPaymentClick}
            onClick={handleFinalPayment}
            loading={confirmPaymentClick}
            className="proceed_btn"
            text="confirm payment"
            sx={{ color: "white" }}
            endIcon={false}
          />
        </div>
        <div className="confirm_order">
          <div className="heading">
            <h1>Order Confirmation</h1>
          </div>
          <div className="order_option">
            <div
              className="paymentMethodSelectorBox"
              style={{ display: "flex", alignItems: "center", gap: "30px" }}
            >
              <Dialog
                sx={{
                  "& .MuiDialog-paper": {
                    width: "80%",
                    maxHeight: 435,
                    background: "#08131F",
                    borderRadius: "16px",
                    border: "1px solid #808080b5",
                  },
                }}
                maxWidth="xs"
                // TransitionProps={{ onEntering: handleEntering }}
                open={openCryptoOptionsBD}
                // onClick={(e) => setOpenCryptoOptionsBD(false)}
              >
                <DialogTitle sx={{ backgroundColor: "#01030c", color: "#fff" }}>
                  Select Coinpayment method
                </DialogTitle>
                <DialogContent
                  dividers
                  sx={{ backgroundColor: "#01030c", color: "#fff" }}
                >
                  {/* <RadioGroup
                    ref={radioGroupRef}
                    aria-label="crypto currencies"
                    name="cryptocurrency"
                    value={selectedCrypto}
                    onChange={(event) => {
                      setSelectedCrypto(event.target.value);
                    }}
                  >
                    {[
                      { label: "ETH", value: "ETH", icon: eth_icon },
                      { label: "USDT", value: "USDT.ERC20", usdt_icon },
                    ].map(({ label, value, icon }) => (
                      <FormControlLabel
                        label={label}
                        value={value}
                        key={value}
                        control={<Radio />}
                        sx={{
                          direction: "flex",
                          alignItems: "center",
                          gap: "20px",
                          height: "94px",
                          padding: "15px 20px",
                          border: "1px solid rgba(255, 255, 255, 0.09)",
                          marginBottom: "10px",
                          borderRadius: "10px",
                          flexDirection: "row-reverse",
                          justifyContent: "space-between",
                        }}
                      />
                    ))}
                  </RadioGroup> */}

                  <div className="options">
                    <div className="options_coins">
                      <div className="heading">
                        <h1>Select Coinpayment method</h1>
                        <img
                          src={crossIcon}
                          onClick={() => {
                            setIsCoinMethodSelected(false);
                            setOpenCryptoOptionsBD(false);
                          }}
                          alt="close modal"
                        />
                      </div>
                      <div className="option_wrapper">
                        {[
                          {
                            label: "USDT-TRON",
                            value: "USDT.TRC20",
                            icon: "https://cryptologos.cc/logos/tron-trx-logo.png?v=029",
                            netWorkType: "NETWORK-TRON",
                          },
                          {
                            label: "USDC-TRON",
                            value: "USDC.TRC20",
                            icon: "https://cryptologos.cc/logos/tron-trx-logo.png?v=029",
                            netWorkType: "NETWORK-TRON",
                          },
                          {
                            label: "COIN-ETH",
                            value: "ETH",
                            icon: eth_icon,
                            netWorkType: "NETWORK-ETH",
                          },
                          {
                            label: "COIN-USDT",
                            value: "USDT.ERC20",
                            icon: usdt_icon,
                            netWorkType: "NETWORK-ETH",
                          },
                          {
                            label: "COIN-USDC",
                            value: "USDC",
                            icon: "https://cryptologos.cc/logos/usd-coin-usdc-logo.png?v=029",
                            netWorkType: "NETWORK-ETH",
                          },
                        ]?.map(({ label, value, icon, netWorkType }) => {
                          return (
                            <label
                              htmlFor={label}
                              className={
                                value === selectedCrypto
                                  ? "optionC selected_coin_method"
                                  : "optionC"
                              }
                              key={value}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  // paddingTop: "20px",
                                }}
                                className="coin-payment-methods"
                              >
                                <img
                                  src={icon}
                                  alt=""
                                  width="10%"
                                  className="coin_icon"
                                />
                                <p>{label}</p>
                              </div>
                              <div className="coinMethonEnd">
                                <input
                                  type="radio"
                                  name="coin"
                                  id={label}
                                  ref={radioGroupRef}
                                  value={value}
                                  checked={
                                    value === selectedCrypto ? true : false
                                  }
                                  onChange={(event) => {
                                    setSelectedCrypto(event.target.value);
                                  }}
                                />
                                <p>{netWorkType}</p>
                              </div>
                            </label>
                          );
                        })}
                      </div>

                      <button
                        className="confirm_btn"
                        onClick={() => setOpenCryptoOptionsBD(false)}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>

                  <button className="confrim_btn">Confirm</button>
                </DialogContent>
              </Dialog>
  
              <div
                className={`paymentMethodItems ${
                  paymentMethod === "coinspayment" ? "payments-active" : ""
                }`}
                id="coinspayment"
                onClick={handlePaymentMethod}
                // style={{background: "#070a12"}}
              >
                <label
                  htmlFor="coinspayment-radio"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className="payment-logo-container coinspayment-logo-container"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      id="coinspayment-radio"
                      checked={paymentMethod === "coinspayment"}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "start",
                        gap: "20px",
                      }}
                    >
                      <img
                        src={coin_icon}
                        alt=""
                        className="payment-logo coinspayment-logo"
                      />
                      <p>CoinPayments</p>
                    </div>
                  </div>
                </label>

                {/* {paymentMethod === "coinspayment" ? <span></span> : <></>} */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isCoindMethodSelected && (
        <CoinPaymentOption setIsCoinMethodSelected={setIsCoinMethodSelected} />
      )}
    </div>
  );
};

export default NewCheckout;

const countries = [
  { code: "AD", label: "Andorra", phone: "376" },
  {
    code: "AE",
    label: "United Arab Emirates",
    phone: "971",
  },
  { code: "AF", label: "Afghanistan", phone: "93" },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    phone: "1-268",
  },
  { code: "AI", label: "Anguilla", phone: "1-264" },
  { code: "AL", label: "Albania", phone: "355" },
  { code: "AM", label: "Armenia", phone: "374" },
  { code: "AO", label: "Angola", phone: "244" },
  { code: "AQ", label: "Antarctica", phone: "672" },
  { code: "AR", label: "Argentina", phone: "54" },
  { code: "AS", label: "American Samoa", phone: "1-684" },
  { code: "AT", label: "Austria", phone: "43" },
  {
    code: "AU",
    label: "Australia",
    phone: "61",
    suggested: true,
  },
  { code: "AW", label: "Aruba", phone: "297" },
  { code: "AX", label: "Alland Islands", phone: "358" },
  { code: "AZ", label: "Azerbaijan", phone: "994" },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    phone: "387",
  },
  { code: "BB", label: "Barbados", phone: "1-246" },
  { code: "BD", label: "Bangladesh", phone: "880" },
  { code: "BE", label: "Belgium", phone: "32" },
  { code: "BF", label: "Burkina Faso", phone: "226" },
  { code: "BG", label: "Bulgaria", phone: "359" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BI", label: "Burundi", phone: "257" },
  { code: "BJ", label: "Benin", phone: "229" },
  { code: "BL", label: "Saint Barthelemy", phone: "590" },
  { code: "BM", label: "Bermuda", phone: "1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "673" },
  { code: "BO", label: "Bolivia", phone: "591" },
  { code: "BR", label: "Brazil", phone: "55" },
  { code: "BS", label: "Bahamas", phone: "1-242" },
  { code: "BT", label: "Bhutan", phone: "975" },
  { code: "BV", label: "Bouvet Island", phone: "47" },
  { code: "BW", label: "Botswana", phone: "267" },
  { code: "BY", label: "Belarus", phone: "375" },
  { code: "BZ", label: "Belize", phone: "501" },
  {
    code: "CA",
    label: "Canada",
    phone: "1",
    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    phone: "61",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    phone: "243",
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "236",
  },
  {
    code: "CG",
    label: "Congo, Republic of the",
    phone: "242",
  },
  { code: "CH", label: "Switzerland", phone: "41" },
  { code: "CI", label: "Cote d'Ivoire", phone: "225" },
  { code: "CK", label: "Cook Islands", phone: "682" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CM", label: "Cameroon", phone: "237" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Colombia", phone: "57" },
  { code: "CR", label: "Costa Rica", phone: "506" },
  { code: "CU", label: "Cuba", phone: "53" },
  { code: "CV", label: "Cape Verde", phone: "238" },
  { code: "CW", label: "Curacao", phone: "599" },
  { code: "CX", label: "Christmas Island", phone: "61" },
  { code: "CY", label: "Cyprus", phone: "357" },
  { code: "CZ", label: "Czech Republic", phone: "420" },
  {
    code: "DE",
    label: "Germany",
    phone: "49",
    suggested: true,
  },
  { code: "DJ", label: "Djibouti", phone: "253" },
  { code: "DK", label: "Denmark", phone: "45" },
  { code: "DM", label: "Dominica", phone: "1-767" },
  {
    code: "DO",
    label: "Dominican Republic",
    phone: "1-809",
  },
  { code: "DZ", label: "Algeria", phone: "213" },
  { code: "EC", label: "Ecuador", phone: "593" },
  { code: "EE", label: "Estonia", phone: "372" },
  { code: "EG", label: "Egypt", phone: "20" },
  { code: "EH", label: "Western Sahara", phone: "212" },
  { code: "ER", label: "Eritrea", phone: "291" },
  { code: "ES", label: "Spain", phone: "34" },
  { code: "ET", label: "Ethiopia", phone: "251" },
  { code: "FI", label: "Finland", phone: "358" },
  { code: "FJ", label: "Fiji", phone: "679" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "500",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "691",
  },
  { code: "FO", label: "Faroe Islands", phone: "298" },
  {
    code: "FR",
    label: "France",
    phone: "33",
    suggested: true,
  },
  { code: "GA", label: "Gabon", phone: "241" },
  { code: "GB", label: "United Kingdom", phone: "44" },
  { code: "GD", label: "Grenada", phone: "1-473" },
  { code: "GE", label: "Georgia", phone: "995" },
  { code: "GF", label: "French Guiana", phone: "594" },
  { code: "GG", label: "Guernsey", phone: "44" },
  { code: "GH", label: "Ghana", phone: "233" },
  { code: "GI", label: "Gibraltar", phone: "350" },
  { code: "GL", label: "Greenland", phone: "299" },
  { code: "GM", label: "Gambia", phone: "220" },
  { code: "GN", label: "Guinea", phone: "224" },
  { code: "GP", label: "Guadeloupe", phone: "590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240" },
  { code: "GR", label: "Greece", phone: "30" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "500",
  },
  { code: "GT", label: "Guatemala", phone: "502" },
  { code: "GU", label: "Guam", phone: "1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "245" },
  { code: "GY", label: "Guyana", phone: "592" },
  { code: "HK", label: "Hong Kong", phone: "852" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "672",
  },
  { code: "HN", label: "Honduras", phone: "504" },
  { code: "HR", label: "Croatia", phone: "385" },
  { code: "HT", label: "Haiti", phone: "509" },
  { code: "HU", label: "Hungary", phone: "36" },
  { code: "ID", label: "Indonesia", phone: "62" },
  { code: "IE", label: "Ireland", phone: "353" },
  { code: "IL", label: "Israel", phone: "972" },
  { code: "IM", label: "Isle of Man", phone: "44" },
  { code: "IN", label: "India", phone: "91" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "246",
  },
  { code: "IQ", label: "Iraq", phone: "964" },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    phone: "98",
  },
  { code: "IS", label: "Iceland", phone: "354" },
  { code: "IT", label: "Italy", phone: "39" },
  { code: "JE", label: "Jersey", phone: "44" },
  { code: "JM", label: "Jamaica", phone: "1-876" },
  { code: "JO", label: "Jordan", phone: "962" },
  {
    code: "JP",
    label: "Japan",
    phone: "81",
    suggested: true,
  },
  { code: "KE", label: "Kenya", phone: "254" },
  { code: "KG", label: "Kyrgyzstan", phone: "996" },
  { code: "KH", label: "Cambodia", phone: "855" },
  { code: "KI", label: "Kiribati", phone: "686" },
  { code: "KM", label: "Comoros", phone: "269" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "1-869",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "850",
  },
  { code: "KR", label: "Korea, Republic of", phone: "82" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "KY", label: "Cayman Islands", phone: "1-345" },
  { code: "KZ", label: "Kazakhstan", phone: "7" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "856",
  },
  { code: "LB", label: "Lebanon", phone: "961" },
  { code: "LC", label: "Saint Lucia", phone: "1-758" },
  { code: "LI", label: "Liechtenstein", phone: "423" },
  { code: "LK", label: "Sri Lanka", phone: "94" },
  { code: "LR", label: "Liberia", phone: "231" },
  { code: "LS", label: "Lesotho", phone: "266" },
  { code: "LT", label: "Lithuania", phone: "370" },
  { code: "LU", label: "Luxembourg", phone: "352" },
  { code: "LV", label: "Latvia", phone: "371" },
  { code: "LY", label: "Libya", phone: "218" },
  { code: "MA", label: "Morocco", phone: "212" },
  { code: "MC", label: "Monaco", phone: "377" },
  {
    code: "MD",
    label: "Moldova, Republic of",
    phone: "373",
  },
  { code: "ME", label: "Montenegro", phone: "382" },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    phone: "590",
  },
  { code: "MG", label: "Madagascar", phone: "261" },
  { code: "MH", label: "Marshall Islands", phone: "692" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "389",
  },
  { code: "ML", label: "Mali", phone: "223" },
  { code: "MM", label: "Myanmar", phone: "95" },
  { code: "MN", label: "Mongolia", phone: "976" },
  { code: "MO", label: "Macao", phone: "853" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "1-670",
  },
  { code: "MQ", label: "Martinique", phone: "596" },
  { code: "MR", label: "Mauritania", phone: "222" },
  { code: "MS", label: "Montserrat", phone: "1-664" },
  { code: "MT", label: "Malta", phone: "356" },
  { code: "MU", label: "Mauritius", phone: "230" },
  { code: "MV", label: "Maldives", phone: "960" },
  { code: "MW", label: "Malawi", phone: "265" },
  { code: "MX", label: "Mexico", phone: "52" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MZ", label: "Mozambique", phone: "258" },
  { code: "NA", label: "Namibia", phone: "264" },
  { code: "NC", label: "New Caledonia", phone: "687" },
  { code: "NE", label: "Niger", phone: "227" },
  { code: "NF", label: "Norfolk Island", phone: "672" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NI", label: "Nicaragua", phone: "505" },
  { code: "NL", label: "Netherlands", phone: "31" },
  { code: "NO", label: "Norway", phone: "47" },
  { code: "NP", label: "Nepal", phone: "977" },
  { code: "NR", label: "Nauru", phone: "674" },
  { code: "NU", label: "Niue", phone: "683" },
  { code: "NZ", label: "New Zealand", phone: "64" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PA", label: "Panama", phone: "507" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PF", label: "French Polynesia", phone: "689" },
  { code: "PG", label: "Papua New Guinea", phone: "675" },
  { code: "PH", label: "Philippines", phone: "63" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PL", label: "Poland", phone: "48" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "508",
  },
  { code: "PN", label: "Pitcairn", phone: "870" },
  { code: "PR", label: "Puerto Rico", phone: "1" },
  {
    code: "PS",
    label: "Palestine, State of",
    phone: "970",
  },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "PW", label: "Palau", phone: "680" },
  { code: "PY", label: "Paraguay", phone: "595" },
  { code: "QA", label: "Qatar", phone: "974" },
  { code: "RE", label: "Reunion", phone: "262" },
  { code: "RO", label: "Romania", phone: "40" },
  { code: "RS", label: "Serbia", phone: "381" },
  { code: "RU", label: "Russian Federation", phone: "7" },
  { code: "RW", label: "Rwanda", phone: "250" },
  { code: "SA", label: "Saudi Arabia", phone: "966" },
  { code: "SB", label: "Solomon Islands", phone: "677" },
  { code: "SC", label: "Seychelles", phone: "248" },
  { code: "SD", label: "Sudan", phone: "249" },
  { code: "SE", label: "Sweden", phone: "46" },
  { code: "SG", label: "Singapore", phone: "65" },
  { code: "SH", label: "Saint Helena", phone: "290" },
  { code: "SI", label: "Slovenia", phone: "386" },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
    phone: "47",
  },
  { code: "SK", label: "Slovakia", phone: "421" },
  { code: "SL", label: "Sierra Leone", phone: "232" },
  { code: "SM", label: "San Marino", phone: "378" },
  { code: "SN", label: "Senegal", phone: "221" },
  { code: "SO", label: "Somalia", phone: "252" },
  { code: "SR", label: "Suriname", phone: "597" },
  { code: "SS", label: "South Sudan", phone: "211" },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    phone: "239",
  },
  { code: "SV", label: "El Salvador", phone: "503" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "1-721",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
    phone: "963",
  },
  { code: "SZ", label: "Swaziland", phone: "268" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "1-649",
  },
  { code: "TD", label: "Chad", phone: "235" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "262",
  },
  { code: "TG", label: "Togo", phone: "228" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TJ", label: "Tajikistan", phone: "992" },
  { code: "TK", label: "Tokelau", phone: "690" },
  { code: "TL", label: "Timor-Leste", phone: "670" },
  { code: "TM", label: "Turkmenistan", phone: "993" },
  { code: "TN", label: "Tunisia", phone: "216" },
  { code: "TO", label: "Tonga", phone: "676" },
  { code: "TR", label: "Turkey", phone: "90" },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    phone: "1-868",
  },
  { code: "TV", label: "Tuvalu", phone: "688" },
  {
    code: "TW",
    label: "Taiwan, Republic of China",
    phone: "886",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "255",
  },
  { code: "UA", label: "Ukraine", phone: "380" },
  { code: "UG", label: "Uganda", phone: "256" },
  {
    code: "US",
    label: "United States",
    phone: "1",
    suggested: true,
  },
  { code: "UY", label: "Uruguay", phone: "598" },
  { code: "UZ", label: "Uzbekistan", phone: "998" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "379",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "1-784",
  },
  { code: "VE", label: "Venezuela", phone: "58" },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "1-284",
  },
  {
    code: "VI",
    label: "US Virgin Islands",
    phone: "1-340",
  },
  { code: "VN", label: "Vietnam", phone: "84" },
  { code: "VU", label: "Vanuatu", phone: "678" },
  { code: "WF", label: "Wallis and Futuna", phone: "681" },
  { code: "WS", label: "Samoa", phone: "685" },
  { code: "XK", label: "Kosovo", phone: "383" },
  { code: "YE", label: "Yemen", phone: "967" },
  { code: "YT", label: "Mayotte", phone: "262" },

  { code: "ZA", label: "South Africa", phone: "27" },
  { code: "ZM", label: "Zambia", phone: "260" },
  { code: "ZW", label: "Zimbabwe", phone: "263" },
];

const CoinPaymentOption = ({ setIsCoinMethodSelected }) => {
  const [selectedBox, setSelectedBox] = useState(0);
  const coindPayments = [
    {
      icon: bitCoinIcon,
      name: "Bitcoins",
    },
    {
      icon: bitCoinIcon,
      name: "Lorem",
    },
    {
      icon: bitCoinIcon,
      name: "Lorems",
    },
  ];
  return (
    <div className="options">
      <div className="options_coins">
        <div className="heading">
          <h1>Select Coinpayment method</h1>
          <img src={crossIcon} onClick={() => setIsCoinMethodSelected(false)} />
        </div>
        {coindPayments?.map((option, index) => {
          return (
            <label
              htmlFor={option.name}
              className={
                selectedBox === index
                  ? "optionC selected_coin_method"
                  : "optionC"
              }
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img src={option.icon} alt="" />
                <p>{option.name}</p>
              </div>
              <input
                type="radio"
                name="coin"
                id={option.name}
                onClick={(e) => setSelectedBox(e.target.checked ? index : null)}
              />
            </label>
          );
        })}
        <button
          className="confirm_btn"
          onClick={() => setIsCoinMethodSelected(false)}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

function TNCModal({ showTNC, onTNC }) {
  return (
    <Grid
      container
      className="tncModal"
      style={{ pointerEvents: !showTNC ? "none" : "auto", top: "0" }}
    >
      <Grid container className="tncModal-container">
        <div onClick={() => onTNC(false)}>
          <svg
            width="40"
            height="40"
            viewBox="0 0 20 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.89355 1L9.78711 5.89355L4.89355 10.7871"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.8105 10.7871L9.91699 5.89356L14.8105 1"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h2>Privacy Policy</h2>
        <p>
          Thank you for choosing to be part of our community at Alpha Capital
          Group Limited (“Company,” “we,” “us,” or “our”). We are committed to
          protecting your personal information and your right to privacy. If you
          have any questions or concerns about this privacy notice or our
          practices with regard to your personal information, please contact us
          at accounts@alphacapitalgroup.uk.
        </p>
        <p>
          This privacy notice describes how we might use your information if
          you:
          <br />
          Visit our website at http://www.alphacapitalgroup.uk
          <br />
          Engage with us in other related ways ― including any sales, marketing,
          or events
        </p>
        <p>
          In this privacy notice, if we refer to:
          <br />
          “Website,” we are referring to any website of ours that references or
          links to this policy
        </p>
        <p>
          “Services,” we are referring to our Website, and other related
          services, including any sales, marketing, or events
        </p>
        <p>
          The purpose of this privacy notice is to explain to you in the
          clearest way possible what information we collect, how we use it, and
          what rights you have in relation to it. If there are any terms in this
          privacy notice that you do not agree with, please discontinue use of
          our Services immediately.
        </p>
        <p>
          Please read this privacy notice carefully, as it will help you
          understand what we do with the information that we collect.
        </p>

        <h3>WHAT INFORMATION DO WE COLLECT?</h3>
        <p>Personal information you disclose to us</p>
        <p>In Short: We collect personal information that you provide to us.</p>
        <p>
          We collect personal information that you voluntarily provide to us
          when you register on the Website, express an interest in obtaining
          information about us or our products and Services, when you
          participate in activities on the Website or otherwise when you contact
          us.
        </p>
        <p>
          The personal information that we collect depends on the context of
          your interactions with us and the Website, the choices you make and
          the products and features you use. The personal information we collect
          may include the following:
        </p>
        <p>
          Personal Information Provided by You. We collect names; phone numbers;
          email addresses; mailing addresses; contact preferences; and other
          similar information.
        </p>
        <p>
          Payment Data. We may collect data necessary to process your payment if
          you make purchases, such as your payment instrument number (such as a
          credit card number), and the security code associated with your
          payment instrument. All payment data is stored by Stripe . You may
          find their privacy notice link(s) here: https://stripe.com/gb/privacy.
        </p>
        <p>
          All personal information that you provide to us must be true, complete
          and accurate, and you must notify us of any changes to such personal
          information.
        </p>
        <p>Information automatically collected</p>
        <p>
          In Short: Some information — such as your Internet Protocol (IP)
          address and/or browser and device characteristics — is collected
          automatically when you visit our Website.
        </p>
        <p>
          We automatically collect certain information when you visit, use or
          navigate the Website. This information does not reveal your specific
          identity (like your name or contact information) but may include
          device and usage information, such as your IP address, browser and
          device characteristics, operating system, language preferences,
          referring URLs, device name, country, location, information about how
          and when you use our Website and other technical information. This
          information is primarily needed to maintain the security and operation
          of our Website, and for our internal analytics and reporting purposes.
        </p>
        <p>The information we collect includes:</p>
        <p>
          Log and Usage Data. Log and usage data is service-related, diagnostic,
          usage and performance information our servers automatically collect
          when you access or use our Website and which we record in log files.
          Depending on how you interact with us, this log data may include your
          IP address, device information, browser type and settings and
          information about your activity in the Website (such as the date/time
          stamps associated with your usage, pages and files viewed, searches
          and other actions you take such as which features you use), device
          event information (such as system activity, error reports (sometimes
          called ‘crash dumps’) and hardware settings). Location Data. We
          collect location data such as information about your device’s
          location, which can be either precise or imprecise. How much
          information we collect depends on the type and settings of the device
          you use to access the Website. For example, we may use GPS and other
          technologies to collect geolocation data that tells us your current
          location (based on your IP address). You can opt out of allowing us to
          collect this information either by refusing access to the information
          or by disabling your Location setting on your device. Note however, if
          you choose to opt out, you may not be able to use certain aspects of
          the Services.
        </p>

        <h3>HOW DO WE USE YOUR INFORMATION?</h3>
        <p>
          In Short: We process your information for purposes based on legitimate
          business interests, the fulfillment of our contract with you,
          compliance with our legal obligations, and/or your consent.
        </p>
        <p>
          We use personal information collected via our Website for a variety of
          business purposes described below. We process your personal
          information for these purposes in reliance on our legitimate business
          interests, in order to enter into or perform a contract with you, with
          your consent, and/or for compliance with our legal obligations. We
          indicate the specific processing grounds we rely on next to each
          purpose listed below.
        </p>
        <p>We use the information we collect or receive:</p>
        <p>
          To facilitate account creation and logon process. If you choose to
          link your account with us to a third-party account (such as your
          Google or Facebook account), we use the information you allowed us to
          collect from those third parties to facilitate account creation and
          logon process for the performance of the contract. To post
          testimonials. We post testimonials on our Website that may contain
          personal information. Prior to posting a testimonial, we will obtain
          your consent to use your name and the content of the testimonial. If
          you wish to update, or delete your testimonial, please contact us at
          support@alphacapitalgroup.uk and be sure to include your name,
          testimonial location, and contact information. Request feedback. We
          may use your information to request feedback and to contact you about
          your use of our Website. To enable user-to-user communications. We may
          use your information in order to enable user-to- user communications
          with each user’s consent.
          <br />
          To manage user accounts. We may use your information for the purposes
          of managing our account and keeping it in working order. To send
          administrative information to you. We may use your personal
          information to send you product, service and new feature information
          and/or information about changes to our terms, conditions, and
          policies.
          <br />
          To protect our Services. We may use your information as part of our
          efforts to keep our Website safe and secure (for example, for fraud
          monitoring and prevention).
          <br />
          To enforce our terms, conditions and policies for business purposes,
          to comply with legal and regulatory requirements or in connection with
          our contract.
          <br />
          To respond to legal requests and prevent harm. If we receive a
          subpoena or other legal request, we may need to inspect the data we
          hold to determine how to respond.
          <br />
          Fulfill and manage your orders. We may use your information to fulfill
          and manage your orders, payments, returns, and exchanges made through
          the Website.
          <br />
          Administer prize draws and competitions. We may use your information
          to administer prize draws and competitions when you elect to
          participate in our competitions.
          <br />
          To deliver and facilitate delivery of services to the user. We may use
          your information to provide you with the requested service.
          <br />
          To respond to user inquiries/offer support to users. We may use your
          information to respond to your inquiries and solve any potential
          issues you might have with the use of our Services.
          <br />
          To send you marketing and promotional communications. We and/or our
          third-party marketing partners may use the personal information you
          send to us for our marketing purposes, if this is in accordance with
          your marketing preferences. For example, when expressing an interest
          in obtaining information about us or our Website, subscribing to
          marketing or otherwise contacting us, we will collect personal
          information from you. You can opt-out of our marketing emails at any
          time (see the “WHAT ARE YOUR PRIVACY RIGHTS?” below).
          <br />
          Deliver targeted advertising to you. We may use your information to
          develop and display personalized content and advertising (and work
          with third parties who do so) tailored to your interests and/or
          location and to measure its effectiveness.
          <br />
          For other business purposes. We may use your information for other
          business purposes, such as data analysis, identifying usage trends,
          determining the effectiveness of our promotional campaigns and to
          evaluate and improve our Website, products, marketing and your
          experience. We may use and store this information in aggregated and
          anonymized form so that it is not associated with individual end users
          and does not include personal information.
        </p>

        <h3>WILL YOUR INFORMATION BE SHARED WITH ANYONE?</h3>
        <p>
          In Short: We only share information with your consent, to comply with
          laws, to provide you with services, to protect your rights, or to
          fulfill business obligations.
        </p>
        <p>
          We may process or share your data that we hold based on the following
          legal basis:
        </p>
        <p>
          Consent: We may process your data if you have given us specific
          consent to use your personal information for a specific purpose.
          <br />
          Legitimate Interests: We may process your data when it is reasonably
          necessary to achieve our legitimate business interests.
          <br />
          Performance of a Contract: Where we have entered into a contract with
          you, we may process your personal information to fulfill the terms of
          our contract.
          <br />
          Legal Obligations: We may disclose your information where we are
          legally required to do so in order to comply with applicable law,
          governmental requests, a judicial proceeding, court order, or legal
          process, such as in response to a court order or a subpoena (including
          in response to public authorities to meet national security or law
          enforcement requirements).
          <br />
          Vital Interests: We may disclose your information where we believe it
          is necessary to investigate, prevent, or take action regarding
          potential violations of our policies, suspected fraud, situations
          involving potential threats to the safety of any person and illegal
          activities, or as evidence in litigation in which we are involved.
          More specifically, we may need to process your data or share your
          personal information in the following situations:
        </p>
        <p>
          Business Transfers. We may share or transfer your information in
          connection with, or during negotiations of, any merger, sale of
          company assets, financing, or acquisition of all or a portion of our
          business to another company.
          <br />
          Vendors, Consultants and Other Third-Party Service Providers. We may
          share your data with third-party vendors, service providers,
          contractors or agents who perform services for us or on our behalf and
          require access to such information to do that work. Examples include:
          payment processing, data analysis, email delivery, hosting services,
          customer service and marketing efforts. We may allow selected third
          parties to use tracking technology on the Website, which will enable
          them to collect data on our behalf about how you interact with our
          Website over time. This information may be used to, among other
          things, analyze and track data, determine the popularity of certain
          content, pages or features, and better understand online activity.
          Unless described in this notice, we do not share, sell, rent or trade
          any of your information with third parties for their promotional
          purposes. We have contracts in place with our data processors, which
          are designed to help safeguard your personal information. This means
          that they cannot do anything with your personal information unless we
          have instructed them to do it. They will also not share your personal
          information with any organization apart from us. They also commit to
          protect the data they hold on our behalf and to retain it for the
          period we instruct.
          <br />
          Affiliates. We may share your information with our affiliates, in
          which case we will require those affiliates to honor this privacy
          notice. Affiliates include our parent company and any subsidiaries,
          joint venture partners or other companies that we control or that are
          under common control with us.
          <br />
          Business Partners. We may share your information with our business
          partners to offer you certain products, services or promotions.
        </p>

        <h3>WHO WILL YOUR INFORMATION BE SHARED WITH?</h3>
        <p>
          In Short: We only share information with the following categories of
          third parties.
        </p>
        <p>
          We only share and disclose your information with the following
          categories of third parties. If we have processed your data based on
          your consent and you wish to revoke your consent, please contact us
          using the contact details provided in the section below titled “HOW
          CAN YOU CONTACT US ABOUT THIS NOTICE?”.
        </p>
        <p>
          Payment Processors
          <br />
          Ad Networks
          <br />
          Data Analytics Services
          <br />
          Finance & Accounting Tools
          <br />
          Order Fulfillment Service Provider
          <br />
          User Account Registration & Authentication Services
        </p>

        <h3>HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
        <p>
          In Short: We keep your information for as long as necessary to fulfill
          the purposes outlined in this privacy notice unless otherwise required
          by law.
        </p>
        <p>
          We will only keep your personal information for as long as it is
          necessary for the purposes set out in this privacy notice, unless a
          longer retention period is required or permitted by law (such as tax,
          accounting or other legal requirements). No purpose in this notice
          will require us keeping your personal information for longer than six
          (6) months past the termination of the user’s account.
        </p>
        <p>
          When we have no ongoing legitimate business need to process your
          personal information, we will either delete or anonymize such
          information, or, if this is not possible (for example, because your
          personal information has been stored in backup archives), then we will
          securely store your personal information and isolate it from any
          further processing until deletion is possible.
        </p>

        <h3>HOW DO WE KEEP YOUR INFORMATION SAFE?</h3>
        <p>
          In Short: We aim to protect your personal information through a system
          of organizational and technical security measures.
        </p>
        <p>
          We have implemented appropriate technical and organizational security
          measures designed to protect the security of any personal information
          we process. However, despite our safeguards and efforts to secure your
          information, no electronic transmission over the Internet or
          information storage technology can be guaranteed to be 100% secure, so
          we cannot promise or guarantee that hackers, cybercriminals, or other
          unauthorized third parties will not be able to defeat our security,
          and improperly collect, access, steal, or modify your information.
          Although we will do our best to protect your personal information,
          transmission of personal information to and from our Website is at
          your own risk. You should only access the Website within a secure
          environment.
        </p>

        <h3>DO WE COLLECT INFORMATION FROM MINORS?</h3>
        <p>
          In Short: We do not knowingly collect data from or market to children
          under 18 years of age.
        </p>
        <p>
          We do not knowingly solicit data from or market to children under 18
          years of age. By using the Website, you represent that you are at
          least 18 or that you are the parent or guardian of such a minor and
          consent to such minor dependent’s use of the Website. If we learn that
          personal information from users less than 18 years of age has been
          collected, we will deactivate the account and take reasonable measures
          to promptly delete such data from our records. If you become aware of
          any data we may have collected from children under age 18, please
          contact us at support@alphacapitalgroup.uk.
        </p>

        <h3>WHAT ARE YOUR PRIVACY RIGHTS?</h3>
        <p>
          In Short: In some regions, such as the European Economic Area (EEA)
          and United Kingdom (UK), you have rights that allow you greater access
          to and control over your personal information. You may review, change,
          or terminate your account at any time.
        </p>
        <p>
          In some regions (like the EEA and UK), you have certain rights under
          applicable data protection laws. These may include the right (i) to
          request access and obtain a copy of your personal information, (ii) to
          request rectification or erasure; (iii) to restrict the processing of
          your personal information; and (iv) if applicable, to data
          portability. In certain circumstances, you may also have the right to
          object to the processing of your personal information. To make such a
          request, please use the contact details provided below. We will
          consider and act upon any request in accordance with applicable data
          protection laws.
        </p>
        <p>
          If we are relying on your consent to process your personal
          information, you have the right to withdraw your consent at any time.
          Please note however that this will not affect the lawfulness of the
          processing before its withdrawal, nor will it affect the processing of
          your personal information conducted in reliance on lawful processing
          grounds other than consent.
        </p>
        <p>
          If you are a resident in the EEA or UK and you believe we are
          unlawfully processing your personal information, you also have the
          right to complain to your local data protection supervisory authority.
          You can find their contact details here:
          <br />
          https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
        </p>
        <p>
          If you are a resident in Switzerland, the contact details for the data
          protection authorities are available here:
          <br />
          https://www.edoeb.admin.ch/edoeb/en/home.html.
        </p>
        <p>
          If you have questions or comments about your privacy rights, you may
          email us at support@alphacapitalgroup.uk.
        </p>
        <p>Account Information</p>
        <p>
          If you would at any time like to review or change the information in
          your account or terminate your account, you can:
        </p>
        <p>
          Contact us using the contact information provided.
          <br /> Upon your request to terminate your account, we will deactivate
          or delete your account and information from our active databases.
          However, we may retain some information in our files to prevent fraud,
          troubleshoot problems, assist with any investigations, enforce our
          Terms of Use and/or comply with applicable legal requirements.
        </p>
        <p>
          Opting out of email marketing: You can unsubscribe from our marketing
          email list at any time by clicking on the unsubscribe link in the
          emails that we send or by contacting us using the details provided
          below. You will then be removed from the marketing email list —
          however, we may still communicate with you, for example to send you
          service-related emails that are necessary for the administration and
          use of your account, to respond to service requests, or for other
          non-marketing purposes. To otherwise opt-out, you may:
        </p>
        <p>Contact us using the contact information provided.</p>

        <h3>CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
        <p>
          Most web browsers and some mobile operating systems and mobile
          applications include a Do-Not-Track (“DNT”) feature or setting you can
          activate to signal your privacy preference not to have data about your
          online browsing activities monitored and collected. At this stage no
          uniform technology standard for recognizing and implementing DNT
          signals has been finalized. As such, we do not currently respond to
          DNT browser signals or any other mechanism that automatically
          communicates your choice not to be tracked online. If a standard for
          online tracking is adopted that we must follow in the future, we will
          inform you about that practice in a revised version of this privacy
          notice.
        </p>

        <h3>DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h3>
        <p>
          In Short: Yes, if you are a resident of California, you are granted
          specific rights regarding access to your personal information.
        </p>
        <p>
          California Civil Code Section 1798.83, also known as the “Shine The
          Light” law, permits our users who are California residents to request
          and obtain from us, once a year and free of charge, information about
          categories of personal information (if any) we disclosed to third
          parties for direct marketing purposes and the names and addresses of
          all third parties with which we shared personal information in the
          immediately preceding calendar year. If you are a California resident
          and would like to make such a request, please submit your request in
          writing to us using the contact information provided below.
        </p>
        <p>
          If you are under 18 years of age, reside in California, and have a
          registered account with the Website, you have the right to request
          removal of unwanted data that you publicly post on the Website. To
          request removal of such data, please contact us using the contact
          information provided below, and include the email address associated
          with your account and a statement that you reside in California. We
          will make sure the data is not publicly displayed on the Website, but
          please be aware that the data may not be completely or comprehensively
          removed from all our systems (e.g. backups, etc.).
        </p>

        <h3>DO WE MAKE UPDATES TO THIS NOTICE?</h3>
        <p>
          In Short: Yes, we will update this notice as necessary to stay
          compliant with relevant laws.
        </p>
        <p>
          We may update this privacy notice from time to time. The updated
          version will be indicated by an updated “Revised” date and the updated
          version will be effective as soon as it is accessible. If we make
          material changes to this privacy notice, we may notify you either by
          prominently posting a notice of such changes or by directly sending
          you a notification. We encourage you to review this privacy notice
          frequently to be informed of how we are protecting your information.
        </p>

        <h3>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
        <p>
          If you have questions or comments about this notice, you may email us
          at support@alphacapitalgroup.uk or by post to:
        </p>
        <p>Alpha Capital Group Limited</p>
        <p>
          10 Lower Thames Street Billingsgate
          <br />
          London EC3R 6AF
        </p>
        <p>United Kingdom</p>

        <h3>
          HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
        </h3>
        <p>
          Based on the applicable laws of your country, you may have the right
          to request access to the personal information we collect from you,
          change that information, or delete it in some circumstances. To
          request to review, update, or delete your personal information, please
          submit a request form by clicking here.
        </p>
      </Grid>
    </Grid>
  );
}